webpackJsonp([1],{

/***/ "+eXy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/9yN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_marked__ = __webpack_require__("EFqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'map',
  data: function data() {
    return {
      ready: false,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      voterPrecinctSelected: '',
      civicAssociationFailure: false,
      voterPrecinctFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedLayerWindowPosition: null,
      selectedItem: {},
      searchText: '',
      filterSelected: [],
      status: '',
      metadata: [],
      mapdata: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["b" /* mapGetters */])(['civicAssociations', 'voterPrecincts']), {
    markdownToHtml: function markdownToHtml() {
      return __WEBPACK_IMPORTED_MODULE_12_marked___default()(this.metadata.Description);
    },

    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected && !this.voterPrecinctSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      if (this.civicAssocationsSelected) {
        var civicCenter = __WEBPACK_IMPORTED_MODULE_10_geolib___default.a.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }
      if (this.voterPrecinctSelected) {
        var voteCenter = __WEBPACK_IMPORTED_MODULE_10_geolib___default.a.getCenter(this.voterPrecinctSelected.paths);
        voteCenter.lat = Number(voteCenter.latitude);
        voteCenter.lng = Number(voteCenter.longitude);

        return voteCenter;
      }
      return this.center;
    },

    filteredItems: function filteredItems() {
      var data = void 0;
      if (this.metadata.Type === 'Layers') {
        if (this.metadata.LayerType === 'VoterPrecinct') {
          data = this.voterPrecincts;
        }
      } else {
        data = this.mapdata;
      }
      return this.filterData(data);
    },

    strapiUrl: function strapiUrl() {
      var url = '';
      //  console.log(process.env.NODE_ENV)
      switch ("production") {
        case 'production':
          url = 'https://strapi.arlingtonva.us';
          break;
        case 'testing':
          url = 'https://strapi.arlingtonva.us';
          break;
        default:
          url = 'https://strapi.arlingtonva.us';
          break;
      }
      return url;
    }
  }),

  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.ready = false;
              _context.next = 3;
              return this.getData();

            case 3:
              this.ready = true;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),

  watch: {
    $route: function $route() {
      this.getData();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapActions */])(['loadCivicAssociations', 'loadVoterPrecincts']), {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.getMetaData().then(_this.getMapData).then(_this.getAdditionalData);

              case 2:
                _context2.t0 = _this.metadata.CivicAssociationFilter;

                if (!_context2.t0) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 6;
                return _this.loadCivicAssociations();

              case 6:
                _context2.t1 = _this.metadata.VoterPrecinctFilter;

                if (!_context2.t1) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 10;
                return _this.loadVoterPrecincts();

              case 10:
                _context2.t2 = _this.metadata.Type === 'Layers' && _this.metadata.LayerType === 'VoterPrecinct';

                if (!_context2.t2) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return _this.getVoterPrecincts();

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getMetaData: function getMetaData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var response, json;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.status = 'loading';
                _context3.next = 3;
                return fetch(_this2.strapiUrl + '/maps?slug=' + _this2.$route.params.slug);

              case 3:
                response = _context3.sent;

                if (response.ok) {
                  _context3.next = 7;
                  break;
                }

                _this2.status = 'error';
                return _context3.abrupt('return');

              case 7:
                _context3.next = 9;
                return response.json();

              case 9:
                json = _context3.sent;

                if (!(json.length === 0)) {
                  _context3.next = 13;
                  break;
                }

                _this2.status = 'not-found';
                return _context3.abrupt('return');

              case 13:

                _this2.metadata = json[0];

                _this2.status = 'ok';
                _this2.metadata.OBJECTID = 'Object ID';
                console.log(_this2.metadata);
                return _context3.abrupt('return', _this2.metadata);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    getMapData: function getMapData(metadata) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var appendTimestamp, data, dateProperties, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, r, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, dp;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                appendTimestamp = metadata.data_source.indexOf('&') > 0 ? '&timestamp=' + new Date().getTime() : '?&timestamp=' + new Date().getTime();
                _context4.next = 3;
                return fetch('' + metadata.data_source + appendTimestamp).then(function (response) {
                  return response.json();
                });

              case 3:
                data = _context4.sent;
                dateProperties = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_own_property_names___default()(data[0]).filter(function (a) {
                  return a.indexOf('Date') > 0;
                });
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context4.prev = 8;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(data);

              case 10:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context4.next = 38;
                  break;
                }

                r = _step.value;

                r.lat = parseFloat(r[metadata.LatIdentifier]);
                r.lng = parseFloat(r[metadata.LonIdentifier]);
                r.icon = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, _this3.icon);
                r.icon.fillColor = _this3.colorPin(r) || '#0040FF';
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 19;
                for (_iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(dateProperties); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  dp = _step2.value;

                  r[dp] = _this3.isIsoDate(r[dp]) ? r[dp].slice(0, 10) : r[dp];
                  r[dp] = r[dp] ? __WEBPACK_IMPORTED_MODULE_13_moment___default()(r[dp]).format('Y-MM-DD') : null;
                }
                _context4.next = 27;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4['catch'](19);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 27:
                _context4.prev = 27;
                _context4.prev = 28;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 30:
                _context4.prev = 30;

                if (!_didIteratorError2) {
                  _context4.next = 33;
                  break;
                }

                throw _iteratorError2;

              case 33:
                return _context4.finish(30);

              case 34:
                return _context4.finish(27);

              case 35:
                _iteratorNormalCompletion = true;
                _context4.next = 10;
                break;

              case 38:
                _context4.next = 44;
                break;

              case 40:
                _context4.prev = 40;
                _context4.t1 = _context4['catch'](8);
                _didIteratorError = true;
                _iteratorError = _context4.t1;

              case 44:
                _context4.prev = 44;
                _context4.prev = 45;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 47:
                _context4.prev = 47;

                if (!_didIteratorError) {
                  _context4.next = 50;
                  break;
                }

                throw _iteratorError;

              case 50:
                return _context4.finish(47);

              case 51:
                return _context4.finish(44);

              case 52:

                _this3.mapdata = data;
                return _context4.abrupt('return', _this3.mapdata);

              case 54:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this3, [[8, 40, 44, 52], [19, 23, 27, 35], [28,, 30, 34], [45,, 47, 51]]);
      }))();
    },
    getAdditionalData: function getAdditionalData(mapdata) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var realEstateUrl, removeStatus, tempData, size, chunkedArray, i, dataArray, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, chunk, queryString, queryUrl, _data, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, r;

        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this4.$route.params.slug === 'permit')) {
                  _context5.next = 66;
                  break;
                }

                realEstateUrl = 'https://datahub-v2.arlingtonva.us/api/RealEstate/Property?$select=realEstatePropertyCode,propertyZipCode,zoningDescListText&$filter=realEstatePropertyCode eq ';

                mapdata = mapdata.filter(function (a) {
                  return a.expiredDate == null;
                });
                removeStatus = ['Awaiting Plans and Documents', 'Application Complete', 'Additional Info Required'];

                mapdata = mapdata.filter(function (a) {
                  return !removeStatus.some(function (b) {
                    return b === a.permitStatusCode;
                  });
                });

                mapdata = mapdata.filter(function (a) {
                  if (mapdata.filter(function (b) {
                    return b.permitNbr === a.permitNbr;
                  }).length > 1 && (a.permitStatusCode === 'Approved' || a.permitStatusCode === 'Denied' || a.permitStatusCode === 'Withdrawn' || a.permitStatusCode === 'Void')) {
                    return a;
                  } else if (mapdata.filter(function (b) {
                    return b.permitNbr === a.permitNbr;
                  }).length === 1) {
                    return a;
                  }
                });
                _this4.mapdata = mapdata;
                tempData = mapdata;
                size = 10;
                chunkedArray = [];

                for (i = 0; i < tempData.length; i += size) {
                  chunkedArray.push(tempData.slice(i, i + size));
                }
                dataArray = [];
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context5.prev = 15;
                _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(chunkedArray);

              case 17:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context5.next = 28;
                  break;
                }

                chunk = _step3.value;
                queryString = chunk.map(function (u) {
                  return '\'' + u.realEstatePropertyCode + '\'';
                }).join(' or realEstatePropertyCode eq ');
                queryUrl = encodeURI(realEstateUrl + queryString);
                _context5.next = 23;
                return fetch(queryUrl).then(function (response) {
                  return response.json();
                });

              case 23:
                _data = _context5.sent;

                dataArray.push(_data);

              case 25:
                _iteratorNormalCompletion3 = true;
                _context5.next = 17;
                break;

              case 28:
                _context5.next = 34;
                break;

              case 30:
                _context5.prev = 30;
                _context5.t0 = _context5['catch'](15);
                _didIteratorError3 = true;
                _iteratorError3 = _context5.t0;

              case 34:
                _context5.prev = 34;
                _context5.prev = 35;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 37:
                _context5.prev = 37;

                if (!_didIteratorError3) {
                  _context5.next = 40;
                  break;
                }

                throw _iteratorError3;

              case 40:
                return _context5.finish(37);

              case 41:
                return _context5.finish(34);

              case 42:
                dataArray = dataArray.flat();
                _this4.mapdata = _this4.mapdata.map(function (obj) {
                  var matched = dataArray.find(function (a) {
                    return a.realEstatePropertyCode === obj.realEstatePropertyCode;
                  });
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, obj, { propertyZipCode: matched.propertyZipCode, zoningDescListText: matched.zoningDescListText });
                });

                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context5.prev = 47;
                for (_iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this4.mapdata); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  r = _step4.value;

                  r.yearSort = __WEBPACK_IMPORTED_MODULE_13_moment___default()(r.issuedDate).year();
                }
                _context5.next = 55;
                break;

              case 51:
                _context5.prev = 51;
                _context5.t1 = _context5['catch'](47);
                _didIteratorError4 = true;
                _iteratorError4 = _context5.t1;

              case 55:
                _context5.prev = 55;
                _context5.prev = 56;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 58:
                _context5.prev = 58;

                if (!_didIteratorError4) {
                  _context5.next = 61;
                  break;
                }

                throw _iteratorError4;

              case 61:
                return _context5.finish(58);

              case 62:
                return _context5.finish(55);

              case 63:
                _this4.addFilterCategory('Zoning District', 'zoningDescListText', _this4.getUniqueItems('zoningDescListText', _this4.mapdata));
                _this4.addFilterCategory('Issued Year', 'yearSort', _this4.getUniqueItems('yearSort', _this4.mapdata).filter(function (a) {
                  return !isNaN(a);
                }));
                return _context5.abrupt('return');

              case 66:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this4, [[15, 30, 34, 42], [35,, 37, 41], [47, 51, 55, 63], [56,, 58, 62]]);
      }))();
    },
    getUniqueItems: function getUniqueItems(prop, list) {
      var uniqueItems = __WEBPACK_IMPORTED_MODULE_7_ramda___default.a.uniq(__WEBPACK_IMPORTED_MODULE_7_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_7_ramda___default.a.prop(prop), list));
      return uniqueItems;
    },
    addFilterCategory: function addFilterCategory(label, field, list) {
      var filterCategoryFilters = list.map(function (a) {
        return {
          'BoxIcon': null,
          'CssClass': null,
          'Field': field,
          'Icon': null,
          'Label': a,
          'Tooltip': null,
          'Value': a
        };
      });
      var filterCategory = {
        Label: label,
        Filters: filterCategoryFilters
      };
      this.metadata.FilterCategory.push(filterCategory);
    },
    isIsoDate: function isIsoDate(str) {
      if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
      var d = new Date(str);
      return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str;
    },
    getVoterPrecincts: function getVoterPrecincts() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var items, url, response, columnHeaders, res;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                /* Map colors */
                items = [];
                url = 'https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson';
                _context6.next = 4;
                return fetch(url).then(function (response) {
                  return response.json();
                });

              case 4:
                response = _context6.sent;
                columnHeaders = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(response.features[0].properties);


                items.length = 0;

                res = _this5.mapdata.map(function (x) {
                  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(x, response.features.find(function (y) {
                    return y.properties.OBJECTID === parseInt(x[_this5.metadata.OBJECTID]);
                  }));
                });

                res.forEach(function (voterPrecinct) {
                  var item = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, voterPrecinct);

                  for (var i = 0; i < columnHeaders.length; i++) {
                    var propertyName = columnHeaders[i];
                    var propertyValue = voterPrecinct[propertyName];
                    item[propertyName] = propertyValue;
                  }
                  try {
                    item.coordinates = voterPrecinct.geometry.coordinates[0];
                    // Setup google map polygon
                    item.paths = [];
                    item.coordinates.forEach(function (coord) {
                      var latLng = {
                        lng: Number(coord[0]),
                        lat: Number(coord[1])
                      };
                      item.paths.push(latLng);
                    });

                    item.popupInfo = item.PREC_NAME;

                    var options = {};
                    options.strokeColor = voterPrecinct.Color;
                    options.strokeOpacity = 0.8;
                    options.strokeWeight = 2;
                    options.fillColor = voterPrecinct.Color;
                    options.fillOpacity = 0.60;

                    item.options = options;
                    items.push(item);
                  } catch (e) {
                    console.log(e);
                  }
                });
                _this5.voterPrecincts = items.sort(function (a, b) {
                  return a.PREC_NAME.localeCompare(b.PREC_NAME);
                });

              case 10:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this5);
      }))();
    },
    colorPin: function colorPin(item) {
      var color = void 0;
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.metadata.FilterCategory), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var category = _step5.value;
          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(category.Filters), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var filter = _step6.value;

              if (item[filter.Field] === filter.Value) {
                color = filter.BoxIcon;
              }
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }
        }
        //  console.log(color);
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      return color;
    },
    filterData: function filterData(items) {
      var _this6 = this;

      if (this.filterSelected.length > 0) {
        this.metadata.FilterCategory.forEach(function (category) {
          if (_this6.filterSelected.some(function (cat) {
            return cat.split(':')[0] === category.Label;
          })) {
            items = items.filter(function (item) {
              return _this6.filterSelected.some(function (selected) {
                var split = selected.split(':');
                return category.Label === split[0] && item[split[1]].toString().toLowerCase() === split[2].toString().toLowerCase();
              });
            });
          }
        });
      }
      return items;
    },
    filterRadius: function filterRadius(items) {
      var _this7 = this;

      if (this.selectedCoordinates && this.radiusSelected) {
        items.map(function (m) {
          m.distance = __WEBPACK_IMPORTED_MODULE_10_geolib___default.a.getDistance({ latitude: _this7.selectedCoordinates.lat, longitude: _this7.selectedCoordinates.lng }, { latitude: m.lat, longitude: m.lng });
        });
        items = items.filter(function (f) {
          return _this7.radiusSelected * 1609 >= f.distance;
        });
      }
      return items;
    },


    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    clearAll: function clearAll() {
      this.filterSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.voterPrecinctSelected = '';
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function setLocation(lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this8 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this8.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this9 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_7_ramda___default.a.find(function (p) {
          return p.id === _this9.selectedItem.id;
        })(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },


    layerClick: function layerClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedLayerWindowPosition = clickEvent.latLng;
    },
    layerWindowCloseClick: function layerWindowCloseClick() {
      this.selectedItem = {};
      this.selectedLayerWindowPosition = null;
    },
    layerWindowCheck: function layerWindowCheck() {
      var _this10 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_7_ramda___default.a.find(function (p) {
          return p.id === _this10.selectedItem.id;
        })(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedLayerWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this11 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_7_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_7_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this11.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this11.subStatusesSelected.splice(i, 1);
        }
      });
    }
  })
});

/***/ }),

/***/ "/ePW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  loadChildCare: function loadChildCare() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/ChildCareProgram.json?&timestamp=' + new Date().getTime()).then(function (result) {
        var data = result.data;
        data.map(function (r) {
          r.name = r['Child Care Center Name'];
          r.contact = r['Contact Person'];
          if (r['Website']) {
            if (r['Website'].indexOf('http') === -1) {
              r['Website'] = 'http://' + r['Website'];
            }
          }
          r.type = 'ChildCare';
          r.lat = parseFloat(r.Lat);
          r.lng = parseFloat(r.Lng);
        });
        resolve(data);
      });
    });
  },
  loadFamilyDayCare: function loadFamilyDayCare() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/FamilyDayCareProgram.json?&timestamp=' + new Date().getTime()).then(function (result) {
        var data = result.data;
        data.map(function (r) {
          r.name = r['Provider Name'];
          r.contact = r['Provider Name'];
          if (r['Website']) {
            if (r['Website'].indexOf('http') === -1) {
              r['Website'] = 'http://' + r['Website'];
            }
          }
          r.type = 'FamilyCare';
          r.lat = parseFloat(r.Lat);
          r.lng = parseFloat(r.Lng);
        });
        resolve(data);
      });
    });
  }
});

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_441f101e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("HIv7");
function injectStyle (ssrContext) {
  __webpack_require__("vctp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_441f101e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0See":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon bus-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M18,11H6V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M4,16C4,16.88 4.39,17.67 5,18.22V20C5,20.55 5.45,21 6,21H7C7.55,21 8,20.55 8,20V19H16V20C16,20.55 16.45,21 17,21H18C18.55,21 19,20.55 19,20V18.22C19.61,17.67 20,16.88 20,16V6C20,2.5 16.42,2 12,2C7.58,2 4,2.5 4,6V16Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Bzr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "printer-icon",
  props: {
    title: {
      type: String,
      default: "Printer icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "2SY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget",staticStyle:{"margin":"0 8px"}},[_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/apartments"}},[_vm._v("Apartments/Condos")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/childcareprograms"}},[_vm._v("Child Care Availability")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/digitalresources"}},[_vm._v("Digital Resources")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/parkaccessibility"}},[_vm._v("Filter Park Amenities to Find a Park that Fits your Needs")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/foodresources"}},[_vm._v("Food Resources")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/map/voter"}},[_vm._v("Voter Turnout")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/map/vaccine"}},[_vm._v("Vaccine Locations")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/map/long-term-care"}},[_vm._v("Long-term Care Communities")])],1)]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',[_c('h3',[_c('router-link',{attrs:{"to":"/polling"}},[_vm._v("Polling Place Locator")])],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n        Engage and Explore with your County Government\n      ")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2UkB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_scanner_vue__ = __webpack_require__("A4Uj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3de96dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_scanner_vue__ = __webpack_require__("ak0r");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_scanner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3de96dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_scanner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_18a64510_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("+eXy");
function injectStyle (ssrContext) {
  __webpack_require__("Qupt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_18a64510_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e987f45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("SgQD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e987f45c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7dF+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7z6R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foodResources_vue__ = __webpack_require__("TTz5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453c47d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_foodResources_vue__ = __webpack_require__("Hmjm");
function injectStyle (ssrContext) {
  __webpack_require__("lpVE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-453c47d5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_foodResources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_453c47d5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_foodResources_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9O9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon desktop-classic-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M6,2C4.89,2 4,2.89 4,4V12C4,13.11 4.89,14 6,14H18C19.11,14 20,13.11 20,12V4C20,2.89 19.11,2 18,2H6M6,4H18V12H6V4M4,15C2.89,15 2,15.89 2,17V20C2,21.11 2.89,22 4,22H20C21.11,22 22,21.11 22,20V17C22,15.89 21.11,15 20,15H4M8,17H20V20H8V17M9,17.75V19.25H13V17.75H9M15,17.75V19.25H19V17.75H15Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A4Uj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "scanner-icon",
  props: {
    title: {
      type: String,
      default: "Scanner icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "DBvs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_digitalResources_vue__ = __webpack_require__("P3cl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70936865_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_digitalResources_vue__ = __webpack_require__("zL/c");
function injectStyle (ssrContext) {
  __webpack_require__("bwJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70936865"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_digitalResources_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70936865_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_digitalResources_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GggO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'childCarePrograms',
  data: function data() {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      childCareProgramsIcon: {},
      familyDayCareProgramsIcon: {},
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      languageSelected: [],
      searchProvider: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['childCarePrograms', 'familyDayCarePrograms']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      return this.center;
    },

    test: function test(item) {
      return item > 10;
    },
    filteredItems: function filteredItems() {
      var _this = this;

      var _ccp = this.childCarePrograms;
      _ccp = _ccp.map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj, { icon: _this.childCareProgramsIcon });
      });
      var _fdcp = this.familyDayCarePrograms;
      _fdcp = _fdcp.map(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj, { icon: _this.familyDayCareProgramsIcon });
      });

      var _tp = _ccp.concat(_fdcp);

      if (this.typeSelected && this.typeSelected.length > 0) {
        if (this.typeSelected.includes('FamilyCare') && this.typeSelected.includes('ChildCare')) {
          // no filter
        } else if (this.typeSelected.includes('FamilyCare')) {
          _tp = _tp.filter(function (f) {
            return f['type'] === 'FamilyCare';
          });
        } else if (this.typeSelected.includes('ChildCare')) {
          _tp = _tp.filter(function (f) {
            return f['type'] === 'ChildCare';
          });
        }
        if (this.typeSelected.includes('Status-Open')) {
          _tp = _tp.filter(function (f) {
            return f['Program Status\r\nOpen/Closed'] === 'Open';
          });
        }
        if (this.typeSelected.includes('Status-Closed')) {
          _tp = _tp.filter(function (f) {
            return f['Program Status\r\nOpen/Closed'] === 'Closed';
          });
        }
        if (this.typeSelected.includes('Available-Slots')) {
          _tp = _tp.filter(function (f) {
            return (/\d/.test(f['# of Current \r\nAvailable Slots']) && f['# of Current \r\nAvailable Slots'] > 0
            );
          });
        }
        if (this.typeSelected.includes('AcceptChildCareSubsidy')) {
          _tp = _tp.filter(function (f) {
            return f['Accepts Child Care Subsidy'] && f['Accepts Child Care Subsidy'].toLowerCase() === 'yes';
          });
        }
        if (this.typeSelected.includes('AcceptVirginiaQuality')) {
          _tp = _tp.filter(function (f) {
            return f['Participates in Virginia Quality'] && f['Participates in Virginia Quality'].toLowerCase() === 'yes';
          });
        }
      }

      if (this.languageSelected.length > 0) {
        _tp = _tp.filter(function (f) {
          if (f['Language']) {
            var languages = f['Language'].split(',');
            var languageSelected = _this.languageSelected.toString();

            return languages.some(function (e) {
              return languageSelected.includes(e.toString());
            });
          }
          return false;
        });
      }

      if (this.searchProvider.length > 0) {
        _tp = _tp.filter(function (f) {
          return f.name && f.name.toLowerCase().includes(_this.searchProvider.toLowerCase());
        });
      }

      return _tp;
    }
  }),
  mounted: function mounted() {
    this.loadChildCarePrograms();
    this.loadFamilyDayCarePrograms();

    this.childCareProgramsIcon = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.icon);
    this.childCareProgramsIcon.fillColor = '#ff0000'; // blue

    this.familyDayCareProgramsIcon = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.icon);
    this.familyDayCareProgramsIcon.fillColor = '#0040FF'; // blue

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected: function statusesSelected() {
      this.infoWindowCheck();
    },
    projectTypesSelected: function projectTypesSelected() {
      this.infoWindowCheck();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapActions */])(['loadChildCarePrograms', 'loadFamilyDayCarePrograms']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    clearAll: function clearAll() {
      this.typeSelected = [];
      this.languageSelected = [];
      this.searchProvider = '';
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function setLocation(lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this2 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this2.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this3 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.find(function (p) {
          return p.id === _this3.selectedItem.id;
        })(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this4 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this4.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this4.subStatusesSelected.splice(i, 1);
        }
      });
    }
  })
});

/***/ }),

/***/ "GrVM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HIv7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Hcid":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  loadFoodResources: function loadFoodResources() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-datasets.s3.amazonaws.com/Uploads/AutomatedJobs/FoodResources.json?&timestamp=' + new Date().getTime()).then(function (result) {
        var data = result.data;
        data.map(function (r) {
          r.lat = parseFloat(r.Lat);
          r.lng = parseFloat(r.Lng);
        });
        resolve(data);
      });
    });
  }
});

/***/ }),

/***/ "HgH/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  // This method will be deprecated once the datahub method is enhanced with poylgon information.
  loadVoterPrecincts: function loadVoterPrecincts() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson').then(function (result) {
        // eslint-disable-next-line
        var headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.data.features[0].properties);
        var mappedData = result.data.features.map(function (m) {
          var obj = {};
          for (var i = 0; i < headers.length; i++) {
            var prop = headers[i];
            var val = m.properties[prop];
            obj[prop] = val;
          }

          obj.coordinates = m.geometry.coordinates[0];

          obj.paths = [];
          obj.coordinates.forEach(function (coord) {
            var latLng = {
              lng: Number(coord[0]),
              lat: Number(coord[1])
            };
            obj.paths.push(latLng);
          });
          return obj;
        });
        var voterPrecincts = mappedData.sort(function (a, b) {
          return a.PREC_NAME < b.PREC_NAME ? -1 : a.PREC_NAME > b.PREC_NAME ? 1 : 0;
        });
        resolve(voterPrecincts);
      });
    });
  },
  loadCivicAssociations: function loadCivicAssociations() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get('https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Civic_Association_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson').then(function (result) {
        // eslint-disable-next-line
        var headers = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result.data.features[0].properties);
        var mappedData = result.data.features.map(function (m) {
          var obj = {};
          for (var i = 0; i < headers.length; i++) {
            var prop = headers[i];
            var val = m.properties[prop];
            obj[prop] = val;
          }

          obj.coordinates = m.geometry.coordinates[0];

          obj.paths = [];
          obj.coordinates.forEach(function (coord) {
            var latLng = {
              lng: Number(coord[0]),
              lat: Number(coord[1])
            };
            obj.paths.push(latLng);
          });
          return obj;
        });
        var civicAssociations = mappedData
        // .filter(m => m.CIVIC && m.CIVIC !== 'Cherry Valley Nature Area')
        .sort(function (a, b) {
          return a.LABEL < b.LABEL ? -1 : a.LABEL > b.LABEL ? 1 : 0;
        });
        resolve(civicAssociations);
      });
    });
  }
});

/***/ }),

/***/ "Hmjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/foodResources"}},[_vm._v(" Food Assistance Resources")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                Filters and Location\n                "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                            "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'FOOD PANTRY',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'FOOD PANTRY')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='FOOD PANTRY',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{staticClass:"icon"})]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'SCHOOL MEALS',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'SCHOOL MEALS')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='SCHOOL MEALS',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'PREPARED MEALS',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'PREPARED MEALS')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='PREPARED MEALS',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'DISCOUNT GROCERIES',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'DISCOUNT GROCERIES')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='DISCOUNT GROCERIES',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Eligibility Features")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Eligibility Requirement',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Eligibility Requirement')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Eligibility Requirement',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Eligibility requirement")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'No Photo ID Required',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'No Photo ID Required')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='No Photo ID Required',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" No Photo ID required")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'No Registration Required',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'No Registration Required')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='No Registration Required',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" No Registration required")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Restricted access (only members of these communities)',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Restricted access (only members of these communities)')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Restricted access (only members of these communities)',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'age_restriction',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'age_restriction')>-1:(_vm.filterSelected)},on:{"change":[function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='age_restriction',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}},function($event){return _vm.ageRestrictionChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Age restrictions")])]),_vm._v(" "),(_vm.filterSelected.includes('age_restriction'))?_c('div',{staticClass:"filter-item filter-item-nested"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Age restrictions - for children (or families of children) only',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Age restrictions - for children (or families of children) only')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Age restrictions - for children (or families of children) only',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.filterSelected.includes('age_restriction'))?_c('div',{staticClass:"filter-item filter-item-nested"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Age restrictions - for seniors only',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Age restrictions - for seniors only')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Age restrictions - for seniors only',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_vm._m(7)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Income maximum for eligibility',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Income maximum for eligibility')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Income maximum for eligibility',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Income maximum")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Program Features")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Delivery Available',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Delivery Available')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Delivery Available',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Delivery Available")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Prepared Meals',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Prepared Meals')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Prepared Meals',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Prepared Meals")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Grocery Items',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Grocery Items')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Grocery Items',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Grocery Items")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Fresh Produce',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Fresh Produce')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Fresh Produce',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Fresh Produce")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Accepts SNAP',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Accepts SNAP')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Accepts SNAP',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Accepts SNAP")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Other Services Provided")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Other services provided - Diapers',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Other services provided - Diapers')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Other services provided - Diapers',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Diapers")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Other services provided - Baby formula',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Other services provided - Baby formula')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Other services provided - Baby formula',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Baby Formula")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Other services provided - Financial assistance',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Other services provided - Financial assistance')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Other services provided - Financial assistance',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Financial Assistance")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Other services provided - Clothing',"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,'Other services provided - Clothing')>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Other services provided - Clothing',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Clothing")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Public Transit")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transitSelected),expression:"transitSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Bus',"checked":Array.isArray(_vm.transitSelected)?_vm._i(_vm.transitSelected,'Bus')>-1:(_vm.transitSelected)},on:{"change":function($event){var $$a=_vm.transitSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Bus',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.transitSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.transitSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.transitSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v("  Bus")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.transitSelected),expression:"transitSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Metro',"checked":Array.isArray(_vm.transitSelected)?_vm._i(_vm.transitSelected,'Metro')>-1:(_vm.transitSelected)},on:{"change":function($event){var $$a=_vm.transitSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Metro',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.transitSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.transitSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.transitSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v("  Metro")])])])]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window two-thirds"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[_vm._l((_vm.filteredItems),function(item){return _c('gmap-marker',{key:item.location_name,attrs:{"position":item,"icon":item.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(item, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},_vm._l((_vm.selectedItem.items),function(selected,index){return _c('div',{key:index,staticClass:"info-window"},[_c('h3',{staticClass:"info-window-header"},[_c('b',[_vm._v(_vm._s(_vm.getLocation(selected)))]),_c('span',{staticClass:"box",class:selected['color'],staticStyle:{"float":"left"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(selected['Location address']))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Hours:")]),_vm._v(" "+_vm._s(selected['Day'])+_vm._s(selected['Times']))]),_c('br'),_vm._v(" "),(selected['Website'] && selected['Website'] != 'N/A')?_c('span',[_c('a',{attrs:{"target":"_blank","href":selected['Website']}},[_vm._v("Website")]),_c('br')]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Contact Name:")]),_vm._v(" "+_vm._s(selected['Name'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Contact Email:")]),_vm._v(" "+_vm._s(selected['Email'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Contact Phone:")]),_vm._v(" "+_vm._s(selected['Phone'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Info:")]),_vm._v(" "+_vm._s(selected['Description'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Eligibility Requirements:")]),_vm._v(" "+_vm._s(selected['Eligibility requirements'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Registration Contact:")]),_vm._v(" "+_vm._s(selected['Registration Contact'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Languages Spoken other than English:")]),_vm._v(" "+_vm._s(selected['Languages Spoken other than English'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Metro:")]),_vm._v(" "+_vm._s(selected['Metro'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Bus:")]),_vm._v(" "+_vm._s(selected['Bus'] || 'N/A')),_c('br')]),_vm._v(" "),_c('br'),_c('br')])}),0),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredItems),function(filterItem,index){return _c('div',{key:index,staticClass:"project"},_vm._l((filterItem.items),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"h3-list"},[_c('b',[_vm._v(_vm._s(_vm.getLocation(item)))]),_c('span',{staticClass:"box",class:item['color'],staticStyle:{"float":"left"}})])]),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_vm._v(_vm._s(item['Location address']))]),_c('br'),_vm._v(" "),(item['Day'])?_c('span',[_c('b',[_vm._v("Hours:")]),_vm._v(" "+_vm._s(item['Day'])+" "+_vm._s(item['Times']))]):_vm._e(),_c('br'),_vm._v(" "),(item['Website'] && item['Website'] != 'N/A')?_c('span',[_c('a',{attrs:{"target":"_blank","href":item['Website']}},[_vm._v("Website")]),_c('br')]):_vm._e()]),_c('br'),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_c('b',[_vm._v("Contact Name:")]),_vm._v(" "+_vm._s(item['Name'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Contact Email:")]),_vm._v(" "+_vm._s(item['Email'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Contact Phone:")]),_vm._v(" "+_vm._s(item['Phone'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Info:")]),_vm._v(" "+_vm._s(item['Description'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Eligibility Requirements:")]),_vm._v(" "+_vm._s(item['Eligibility requirements'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Registration Contact:")]),_vm._v(" "+_vm._s(item['Registration Contact'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Languages Spoken other than English:")]),_vm._v(" "+_vm._s(item['Languages Spoken other than English'] || 'N/A'))]),_c('br'),_vm._v(" "),_c('span',[_c('b',[_vm._v("Metro:")]),_vm._v(" "+_vm._s(item['Metro'] || 'N/A')),_c('br')]),_vm._v(" "),_c('span',[_c('b',[_vm._v("Bus:")]),_vm._v(" "+_vm._s(item['Bus'] || 'N/A')),_c('br')])]),_c('br')])}),0)}),0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n              Arlington has many food assistance resources available to ensure that any resident who needs help can get the food they need to feed themselves and their families. This map shows the locations of food pantries, Arlington Public Schools Grab-and-Go meals, and restaurants offering meals to families in need.\n              For information on additional food assistance resources, please call 703-228-1300 or go to the\n              "),_c('a',{attrs:{"href":"https://www.arlingtonva.us/covid-19/food-assistance/"}},[_vm._v("Arlington County food assistance resources website")]),_vm._v(".\n              If you know of updates to the information on this map, please send them to "),_c('a',{attrs:{"href":"mailto:foodassistance@arlingtonva.us"}},[_vm._v("foodassistance@arlingtonva.us")])]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Food Pantry\n                            "),_c('span',{staticClass:"box blue"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" School Meals\n                            "),_c('span',{staticClass:"box red"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Prepared Meals\n                            "),_c('span',{staticClass:"box green"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Discount Groceries\n                            "),_c('span',{staticClass:"box purple"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Restricted access\n                              "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Only members of these communities")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Children\n                              "),_c('span',{staticClass:"tooltiptext"},[_vm._v("For Children or Families with Children")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v("  Seniors\n                              "),_c('span',{staticClass:"tooltiptext"},[_vm._v("For Seniors only")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I2zp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'apartments',
  data: function data() {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['apartments', 'civicAssociations']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        console.log(this.civicAssocationsSelected);
        var civicCenter = __WEBPACK_IMPORTED_MODULE_2_geolib___default.a.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    filteredApartments: function filteredApartments() {
      var _this = this;

      var filterByType = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.filter(function (f) {
        return !_this.typeSelected || _this.typeSelected.length === 0 || _this.typeSelected.indexOf(f.complexTypeName) >= 0;
      });
      var filterByCivic = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.filter(function (f) {
        return !_this.selectedCivicInfo || f.civicAssociationKey === _this.selectedCivicInfo.civicAssociationKey;
      });

      var sortByTitle = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.toLower, __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('complexName')));
      return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(sortByTitle, filterByType, filterByCivic)(this.apartments);
    }
    /* selectedCivicInfo: function () {
      if (this.civicAssocationsSelected !== '') {
        return this.civicInfo.find(f => f.civicAssociationGisId === this.civicAssocationsSelected.id);
      }
    },
    selectedItemCivic: function () {
      if (this.selectedItem) {
        console.log(this.selectedItem)
        return this.civicInfo.find(f => f.civicAssociationKey === this.selectedItem.civicAssociationKey);
      }
    } */
  }),
  mounted: function mounted() {
    this.loadApartments();
    this.loadCivicAssociations();

    this.isMobile = window.innerWidth < 600;

    if (this.queryStatus) {
      var split = this.queryStatus.split(',');
      this.statusesSelected = split;
      this.filtersExpanded = true;
    }

    if (this.querySubStatus) {
      var statusSplit = this.querySubStatus.split(',');
      this.subStatusesSelected = statusSplit;
      this.filtersExpanded = true;
    }

    if (this.queryProjectType) {
      var projSplit = this.queryProjectType.split(',');
      console.log('Projects', projSplit);
      var joined = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.innerJoin(function (record, label) {
        return record.label === label;
      }, this.projectTypes);
      var values = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'));

      this.projectTypesSelected = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(values, joined)(projSplit);
      this.filtersExpanded = true;
    }
  },
  watch: {
    statusesSelected: function statusesSelected() {
      this.infoWindowCheck();
    },
    projectTypesSelected: function projectTypesSelected() {
      this.infoWindowCheck();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['loadApartments', 'loadCivicAssociations']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    clearAll: function clearAll() {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this2 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this2.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this3 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.find(function (p) {
          return p.id === _this3.selectedItem.id;
        })(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this4 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this4.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this4.subStatusesSelected.splice(i, 1);
        }
      });
    }
  })
});

/***/ }),

/***/ "J6rN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "subway-variant-icon",
  props: {
    title: {
      type: String,
      default: "Subway variant icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "JgPu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JpvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCarePrograms_vue__ = __webpack_require__("GggO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09002302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_childCarePrograms_vue__ = __webpack_require__("ePK3");
function injectStyle (ssrContext) {
  __webpack_require__("rmnd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-09002302"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_childCarePrograms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09002302_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_childCarePrograms_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kdw1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__ = __webpack_require__("wWHd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00581925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__ = __webpack_require__("zuWS");
function injectStyle (ssrContext) {
  __webpack_require__("OI2U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00581925"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Projects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00581925_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Projects_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LS7O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_bus_vue__ = __webpack_require__("kK5u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4811d19a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_bus_vue__ = __webpack_require__("0See");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_bus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4811d19a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_bus_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LgQQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256d82fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("TFfO");
function injectStyle (ssrContext) {
  __webpack_require__("LgQQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256d82fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MA+3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_subway_variant_vue__ = __webpack_require__("J6rN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_333cfabd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_subway_variant_vue__ = __webpack_require__("f3QL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_subway_variant_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_333cfabd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_subway_variant_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MsJX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  loadDigitalResources: function loadDigitalResources() {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/DigitalResources.json?&timestamp=' + new Date().getTime()).then(function (result) {
        var data = result.data;
        data.map(function (r) {
          if (r['Phone Number']) {
            r['Phone Number'] = r['Phone Number'].toString();
            if (r['Phone Number'].indexOf(',')) {
              var h = r['Phone Number'].split(',');
              if (h.length > 1) {
                h = h.map(function (p) {
                  return _this.formatPhoneNumber(p.replace(/(\r\n|\n|\r)/gm, ''));
                });
                if (h) {
                  r['Phone Number'] = h.join(', ');
                }
              } else {
                r['Phone Number'] = _this.formatPhoneNumber(r['Phone Number']);
              }
            } else {
              r['Phone Number'] = _this.formatPhoneNumber(r['Phone Number']);
            }
          }
          if (r['Hours'] && r['Hours'] !== 'N/A' && r['Days of Operation'] && r['Days of Operation'] !== 'N/A') {
            r['Hours'] = r['Hours'].split(',');
            r['Days of Operation'] = r['Days of Operation'].split(',');
          }
          r.lat = parseFloat(r.Lat);
          r.lng = parseFloat(r.Lng);
          if (r['Reservation Requirements'] != null && r['Reservation Requirements'] !== 'N/A') {
            r['Reservation Requirements'] = '<span>' + r['Reservation Requirements'] + '</span>';
          }
          if (r['Notes/comments'] != null && r['Notes/comments'] !== 'N/A') {
            r['Notes/comments'] = '<span>' + r['Notes/comments'] + '</span>';
          }
        });
        data.sort(function (a, b) {
          var nameA = a.Facility.toUpperCase(); // ignore upper and lowercase
          var nameB = b.Facility.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
        resolve(data);
      });
    });
  },
  formatPhoneNumber: function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
});

/***/ }),

/***/ "NBDf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);



/* harmony default export */ __webpack_exports__["a"] = ({
  loadParkAccessibilities: function loadParkAccessibilities() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-v2-s3.arlingtonva.us/Uploads/AutomatedJobs/ParksAccessibility.json?&timestamp=' + new Date().getTime()).then(function (result) {
        var data = result.data;
        data.map(function (r) {
          r.lat = parseFloat(r.Lat);
          r.lng = parseFloat(r.Lng);

          r.parking = false;
          if (r['Parking Access']) {
            r.parking = r['Parking Access'].toLowerCase().includes('accessible spots') || r['Parking Access'].toLowerCase().includes('garage');
          }

          r.restroom = false;
          if (r['Restroom Access']) {
            r.restroom = !r['Restroom Access'].toLowerCase().includes('no restroom on site');
          }

          r.playgroundequip = false;
          if (r['accessible playground equip.']) {
            r.playgroundequip = !r['accessible playground equip.'].toLowerCase().includes('none');
          }

          r.seats = false;
          if (r['seating']) {
            r.seats = r['seating'].toLowerCase() !== 'none';
          }

          r.freshwater = false;
          if (r['Fresh Water on Site'] && r['Fresh Water on Site'].toLowerCase() === 'stream/pond on site') {
            r['Fresh Water on Site'] = 'Access to Pond/Stream';
          }
          if (r['Fresh Water on Site'] && r['Fresh Water on Site'].toLowerCase() === 'no access to stream/pond') {
            r['Fresh Water on Site'] = 'No access to Pond/Stream';
          }

          r.playarea = false;
          if (r['Play Area on Site']) {
            r.playarea = r['Play Area on Site'].toLowerCase() === 'yes';
          }

          // change shade covers to sun cover
          if (r['Access to Sun Cover'] === 'no shade cover') {
            r['Access to Sun Cover'] = 'no sun cover';
          }

          // changes to Play/Park Access
          if (r['Play/Park Access'] === 'ramp/zero dimension and stair access') {
            r['Play/Park Access'] = 'ramp and stair access';
          }
        });
        resolve(data);
      });
    });
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_gtag__ = __webpack_require__("Z3T5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__("wtEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_styles_css__ = __webpack_require__("siN1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_design_icons_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_gtag__["a" /* default */], {
  config: { id: 'G-BSNCGMV709' }
}, __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
var vue = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
  template: '<App />',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

console.log(vue);

/***/ }),

/***/ "O56c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['projects']), {
    filteredProjects: function filteredProjects() {
      if (this.search === '') {
        return this.projects;
      } else {
        var regex = new RegExp(this.search, 'i');

        return this.projects.filter(function (p) {
          return p.title && p.title.match(regex);
        });
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['loadProjects'])),
  mounted: function mounted() {
    this.loadProjects();
  }
});

/***/ }),

/***/ "OI2U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OYSh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);




var calculateParentStatus = function calculateParentStatus(status) {
  switch (status) {
    case 'Preliminary Proposal':
    case 'Final Proposal':
    case 'Final Submittal':
    case 'Under Review':
    case 'On Hold':
    case 'Expired':
    case 'No Status':
      return 'Proposed';
    case 'Approved':
    case 'Planned':
    case 'In Design':
    case 'Procurement':
    case 'Out to Bid':
      return 'Approved';
    case 'Construction':
      return 'Construction';
    case 'Complete':
      return 'Complete';
    default:
      return null;
  }
};

var formattedStatus = function formattedStatus(status, subStatus) {
  if (status !== subStatus) {
    return status + ' - ' + subStatus;
  }

  return status;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  loadProjects: function loadProjects() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub.arlingtonva.us/api/HousingBuilding/HighlightedDevelopmentProject?format=json').then(function (result) {
        var projects = result.data.map(function (project) {
          if (project.projectCoordinates) {
            var projectTypeList = project.projectTypeList || '';

            var coords = null;
            if (project.projectCoordinates !== 'undefined' && project.projectCoordinates !== 'null') {
              var temp = JSON.parse(project.projectCoordinates.replace(/lat/g, '\'lat\'').replace(/lng/g, '\'lng\'').replace(/,]/g, ']'));
              coords = __WEBPACK_IMPORTED_MODULE_2_ramda___default.a.map(function (m) {
                var crds = null;
                if (m.coordinates && m.coordinates.replace) {
                  crds = JSON.parse(m.coordinates.replace(/'lat'/g, '"lat"').replace(/'lng'/g, '"lng"'));
                } else if (m.coordinates && m.coordinates.push) {
                  crds = m.coordinates.map(function (m) {
                    return { lat: m['\'lat\''], lng: m['\'lng\''] };
                  });
                } else if (m.coordinates && m.coordinates["'lat'"] && m.coordinates["'lng'"]) {
                  // console.log('Does this hit?')
                  crds = {
                    lat: m.coordinates["'lat'"],
                    lng: m.coordinates["'lng'"]
                  };
                } else {}

                return {
                  shape: m.shape,
                  coordinates: crds
                };
              })(temp);
            }

            var parentStatus = calculateParentStatus(project.projectStatusCode);
            var content = formattedStatus(parentStatus, project.projectStatusCode) + '<br />' + projectTypeList.replace(',', ', ');

            var types = projectTypeList.split(',').map(function (p) {
              return { name: p };
            });
            if (projectTypeList.indexOf('Form Based Code') > -1) {
              types.push({ name: 'Site Plan Project' });
            }
            return {
              title: project.projectTitleText,
              status: parentStatus,
              subStatus: project.projectStatusCode,
              url: project.projectUrlText,
              id: project.highlightedDevelopmentProjectKey,
              projects: types,
              developerName: project.developerName,
              rpc: project.realEstatePropertyCode,
              completionDate: project.completionDate,
              address: project.developmentProjectAddressText,
              buildingPermitList: project.buildingPermitList,
              content: content,
              shapes: coords,
              hideProject: project.hidePolygonInd,
              hideUrl: project.privateUrlInd
            };
          }
        });
        var filtered = projects.filter(function (project) {
          return project && project.shapes && project.shapes[0].coordinates && !project.hideProject;
        }).filter(function (p) {
          var condition = p.projects.find(function (f) {
            return f.name === 'Neighborhood';
          }) || p.projects.find(function (f) {
            return f.name === 'National Historic Place';
          }) || p.projects.find(function (f) {
            return f.name === 'Local Historic District';
          }) || p.projects.find(function (f) {
            return f.name === 'Historic Resources Inventory';
          }) || p.projects.length === 1 && p.projects[0].name === '' || p.projects.length === 0;

          return !condition;
        });
        resolve(filtered);
      });
    });
  },
  loadDailyWork: function loadDailyWork() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub.arlingtonva.us/waze/roadclosuresjson').then(function (result) {
        var roadClosures = result.data.map(function (closure) {
          var paths = [];
          paths.push({
            lat: closure.VwDisruption.StartStreetSectionDisruptionLatitudeCrd,
            lng: closure.VwDisruption.StartStreetSectionDisruptionLongitudeCrd
          });
          paths.push({
            lat: closure.VwDisruption.EndingStreetSectionDisruptionLatitudeCrd,
            lng: closure.VwDisruption.EndingStreetSectionDisruptionLongitudeCrd
          });

          return {
            id: closure.VwDisruption.DisruptionKey,
            shapes: {
              0: {
                shape: 'polyline',
                coordinates: paths
              }
            },
            status: 'Construction',
            subStatus: 'Construction',
            projects: [{ name: 'Daily Work' }],
            title: closure.VwDisruption.AffectedStreetName || '',
            content: closure.VwDisruption.DisruptionDsc,
            url: 'https://transportation.arlingtonva.us/streets/street-maintenance/'
          };
        });
        var uniq = __WEBPACK_IMPORTED_MODULE_2_ramda___default.a.uniqBy(function (a) {
          return a.title + '|' + a.content;
        }, roadClosures);
        resolve(uniq);
      });
    });
  },
  loadPermitsForProject: function loadPermitsForProject(project) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub.arlingtonva.us/api/HousingBuilding/HighlightedDevelopmentProjectPermit?format=json&$filter=HighlightedProjectId%20eq%20' + project.id).then(function (response) {
        resolve(response.data);
      });
    });
  }
});

/***/ }),

/***/ "OcEu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "P3cl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__("aFK5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_scanner_vue__ = __webpack_require__("2UkB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_printer_vue__ = __webpack_require__("hzdq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_wifi_vue__ = __webpack_require__("szM1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_desktop_classic_vue__ = __webpack_require__("pq0S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_bus_vue__ = __webpack_require__("LS7O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_material_design_icons_subway_variant_vue__ = __webpack_require__("MA+3");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'digitalResources',
  components: {
    ScannerIcon: __WEBPACK_IMPORTED_MODULE_9_vue_material_design_icons_scanner_vue__["a" /* default */],
    PrinterIcon: __WEBPACK_IMPORTED_MODULE_10_vue_material_design_icons_printer_vue__["a" /* default */],
    WifiIcon: __WEBPACK_IMPORTED_MODULE_11_vue_material_design_icons_wifi_vue__["a" /* default */],
    DesktopIcon: __WEBPACK_IMPORTED_MODULE_12_vue_material_design_icons_desktop_classic_vue__["a" /* default */],
    BusIcon: __WEBPACK_IMPORTED_MODULE_13_vue_material_design_icons_bus_vue__["a" /* default */],
    SubwayIcon: __WEBPACK_IMPORTED_MODULE_14_vue_material_design_icons_subway_variant_vue__["a" /* default */]
  },
  data: function data() {
    return {
      alert: true,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      facilitySelected: '',
      facilityTypeSelected: '',
      civicAssociationFailure: false,
      filterQuery: {},
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapGetters */])(['digitalResources']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        var civicCenter = __WEBPACK_IMPORTED_MODULE_5_geolib___default.a.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    facilities: function facilities() {
      return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.digitalResources.map(function (item) {
        return item.Facility;
      }))));
    },
    facilityTypes: function facilityTypes() {
      var types = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(this.digitalResources.map(function (item) {
        return item['Facility Type'];
      }))));
      types.sort();
      return types;
    },
    filteredDigitalResources: function filteredDigitalResources() {
      var _this = this;

      var _dr = this.digitalResources;
      if (this.typeSelected && this.typeSelected.length > 0) {
        if (this.typeSelected.includes('Computer')) {
          this.filterQuery.Computer = true;
          _dr = _dr.filter(function (f) {
            return f['Computers available?'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('IndoorWiFi') && this.typeSelected.includes('DriveWiFi')) {
          _dr = _dr.filter(function (f) {
            return f['Wi-Fi'] === 'Yes';
          });
        }
        if (!this.typeSelected.includes('DriveWiFi') && this.typeSelected.includes('IndoorWiFi')) {
          _dr = _dr.filter(function (f) {
            return f['Wi-Fi'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('DriveWiFi') && !this.typeSelected.includes('IndoorWiFi')) {
          _dr = _dr.filter(function (f) {
            return f['Availability'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('Training')) {
          _dr = _dr.filter(function (f) {
            return f['Trainings'] !== null && f['Trainings'] !== 'No' && f['Trainings'] !== 'N/A';
          });
        }
        if (this.typeSelected.includes('Printing')) {
          this.filterQuery.Printing = true;
          _dr = _dr.filter(function (f) {
            return f['Printing'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('Scanning')) {
          this.filterQuery.Scanning = true;
          _dr = _dr.filter(function (f) {
            return f['Scanning'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('Bus')) {
          this.filterQuery.Bus = true;
          _dr = _dr.filter(function (f) {
            return f['Bus'] === 'Yes';
          });
        }
        if (this.typeSelected.includes('Metro')) {
          this.filterQuery.Metro = true;
          _dr = _dr.filter(function (f) {
            return f['Metro'] === 'Yes';
          });
        }
      }
      if (this.facilitySelected) {
        _dr = _dr.filter(function (f) {
          return f.Facility === _this.facilitySelected;
        });
      }
      if (this.facilityTypeSelected) {
        _dr = _dr.filter(function (f) {
          return f['Facility Type'] === _this.facilityTypeSelected;
        });
      }
      if (this.selectedCoordinates && this.radiusSelected) {
        _dr.map(function (m) {
          m.distance = __WEBPACK_IMPORTED_MODULE_5_geolib___default.a.getDistance({ latitude: _this.selectedCoordinates.lat, longitude: _this.selectedCoordinates.lng }, { latitude: m.lat, longitude: m.lng });
        });
        _dr = _dr.filter(function (f) {
          return _this.radiusSelected * 1609 >= f.distance;
        });
      }
      this.$router.push({ query: this.filterQuery });
      return _dr;
    }
  }),
  beforeMount: function beforeMount() {
    var _this2 = this;

    this.typeSelected = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(this.$route.query);
    this.typeSelected.forEach(function (a) {
      if (a === 'facility' || a === 'facilitytype') {
        return;
      }
      _this2.filterQuery[a] = true;
    });

    this.filterQuery.facility = this.$route.query.facility || '';
    this.filterQuery.facilitytype = this.$route.query.facilitytype || '';
    if (!this.$route.query.facility || this.$route.query.facility === '') {
      delete this.filterQuery.facility;
    }
    if (!this.$route.query.facilitytype || this.$route.query.facilitytype === '') {
      delete this.filterQuery.facilitytype;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.loadDigitalResources().then(function () {
      _this3.facilitySelected = _this3.filterQuery.facility || '';
      _this3.facilityTypeSelected = _this3.filterQuery.facilitytype || '';
    });

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected: function statusesSelected() {
      this.infoWindowCheck();
    },
    projectTypesSelected: function projectTypesSelected() {
      this.infoWindowCheck();
    },
    facilitySelected: function facilitySelected() {
      if (this.facilitySelected && this.filteredDigitalResources.length > 0) {
        this.setLocation(this.filteredDigitalResources[0].lat, this.filteredDigitalResources[0].lng, true);
      } else {
        this.selectedCoordinates = null;
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapActions */])(['loadDigitalResources']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    wifiChange: function wifiChange(ev) {
      if (this.typeSelected.includes('WiFi')) {
        this.filterQuery.WiFi = true;
        if (this.typeSelected.includes('IndoorWiFi')) {
          this.filterQuery.IndoorWiFi = true;
        }
        if (this.typeSelected.includes('DriveWiFi')) {
          this.filterQuery.DriveWiFi = true;
        }
      } else {
        this.typeSelected = this.typeSelected.filter(function (a) {
          return a !== 'IndoorWiFi' && a !== 'DriveWiFi';
        });
        delete this.filterQuery['DriveWiFi'];
        delete this.filterQuery['IndoorWiFi'];
      }
      this.filterChange(ev);
    },
    filterChange: function filterChange(ev) {
      if (!this.typeSelected.includes(ev.srcElement.value)) {
        delete this.filterQuery[ev.srcElement.value];
      }
      this.$router.push({ query: this.filterQuery });
    },
    facilityChange: function facilityChange(ev) {
      this.filterQuery[ev.srcElement.id] = ev.srcElement.value;
      if (!ev.srcElement.value || ev.srcElement.value === '') {
        delete this.filterQuery[ev.srcElement.id];
      }
      this.$router.push({ query: this.filterQuery });
    },
    clearAll: function clearAll() {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.typeSelected = [];
      this.selectedCoordinates = null;
      this.facilitySelected = '';
      this.facilityTypeSelected = '';
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.filterQuery = {};
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function setLocation(lat, lng, facility) {
      this.selectedCoordinates = { lat: lat, lng: lng, fac: facility };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this4 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this4.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this5 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_4_ramda___default.a.find(function (p) {
          return p.id === _this5.selectedItem.id;
        })(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this6 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_4_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_4_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this6.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this6.subStatusesSelected.splice(i, 1);
        }
      });
    },
    openLink: function openLink(link) {
      window.open(link, '_blank');
    },
    openCovidPage: function openCovidPage() {
      window.open('https://www.arlingtonva.us/covid-19/operational-status/', '_blank');
    }
  })
});

/***/ }),

/***/ "Qupt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SAZf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Polling Place Locator")])],1),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n               Enter address to find voting location.\n            ")])])]),_vm._v(" "),_c('v-flex',{staticClass:"layer-page"}),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                  Filters and Location\n                  "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                              "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])])]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),(_vm.voterPrecinctSelected)?_c('div',{staticClass:"filter-container zoom-container"},[_c('h3',[_vm._v(_vm._s(_vm.voterPrecinctSelected.PREC_NAME)+" - "+_vm._s(_vm.voterPrecinctSelected.POLLING_PLACE))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.voterPrecinctSelected.ADDRESS))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[(_vm.selectedCoordinates && !_vm.selectedCoordinates.fac)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.voterPrecinctSelected)?_c('gmap-polygon',{attrs:{"path":_vm.voterPrecinctSelected.paths,"options":_vm.locationOptions},on:{"click":function (e) { return _vm.infoClick(_vm.voterPrecinctSelected, e); }}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e(),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('h3',{staticClass:"info-window-header"},[_c('b',[_vm._v(_vm._s(_vm.selectedItem.PREC_NAME)+" - "+_vm._s(_vm.selectedItem.POLLING_PLACE))])]),_vm._v(" "),_c('div',{staticClass:"info-window-body"},[_vm._v("\n                          "+_vm._s(_vm.selectedItem.ADDRESS)+"\n                        ")])])],1)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SgQD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TFfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.embed)?_c('div',{staticClass:"wrap"},[_c('v-toolbar',{staticStyle:{"margin-bottom":"-50px"},attrs:{"color":"#005cb8","flat":"","dense":""}},[_c('a',{staticClass:"mx-2 pa-0",staticStyle:{"width":"220px","height":"38px","overflow":"hidden"},attrs:{"href":"https://arlingtonva.us"}},[_c('v-img',{staticClass:"my-auto",attrs:{"max-height":"38","max-width":"220","position":"top, left","src":"https://www.arlingtonva.us/files/oc-templates/00000000-0000-0000-0000-000000000000/48e205af-32b5-43fa-97d5-785a9f23ed57/arlington-logo.svg?t=637703207315439537"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items')],1)],1):_vm._e(),_vm._v(" "),_c('v-app',{class:{ embedded: _vm.embed }},[_c('router-view')],1),_vm._v(" "),(!_vm.embed)?_c('v-footer',{attrs:{"color":"#005cb8"}},[_c('p',{staticClass:"ma-auto white--text body-2"},[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" Arlington County Virginia")])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TTz5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__("+6Bu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'foodResourceMap',
  data: function data() {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      foodPantryIcon: {},
      schoolMealsIcon: {},
      restaurantIcon: {},
      discountGroceryIcon: {},
      farmersMarketIcon: {},
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      filterSelected: [],
      transitSelected: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['foodResources']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      return this.center;
    },

    filteredItems: function filteredItems() {
      var _this = this;

      var items = this.foodResources;

      if (this.filterSelected.length > 0) {
        items = items.filter(function (item) {
          return _this.filterSelected.some(function (selected) {
            return item[selected] && (item[selected].toUpperCase() === 'TRUE' || item[selected].toUpperCase() === 'X');
          });
        });
      }

      if (this.transitSelected.length > 0) {
        items = items.filter(function (item) {
          return _this.transitSelected.some(function (selected) {
            return item[selected];
          });
        });
      }

      if (this.typeSelected.length > 0) {
        items = items.filter(function (item) {
          return _this.typeSelected.includes(item['Type'].toString().toUpperCase());
        });
      }

      var reducer = function reducer(groupBy, el) {
        if (Array.isArray(el)) {
          return el.reduce(reducer, groupBy);
        } else {
          var lat = el.lat,
              lng = el.lng,
              rest = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(el, ['lat', 'lng']);

          var group = groupBy.find(function (el) {
            return el.lat === lat && el.lng === lng;
          });
          rest.color = rest['Type'].toUpperCase() === 'FOOD PANTRY' ? 'blue' : rest['Type'].toUpperCase() === 'SCHOOL MEALS' ? 'red' : rest['Type'].toUpperCase() === 'PREPARED MEALS' ? 'green' : 'purple';
          if (group) {
            group.items.push(rest);
          } else {
            groupBy.push({
              lat: lat,
              lng: lng,
              icon: rest.Type.toUpperCase() === 'FOOD PANTRY' ? _this.foodPantryIcon : rest.Type.toUpperCase() === 'SCHOOL MEALS' ? _this.schoolMealsIcon : rest.Type.toUpperCase() === 'PREPARED MEALS' ? _this.restaurantIcon : rest.Type.toUpperCase() === 'DISCOUNT GROCERIES' ? _this.discountGroceryIcon : _this.icon,
              items: [rest]
            });
          }
          return groupBy;
        }
      };
      var items2 = items.reduce(reducer, []);
      return items2;
    }

  }),
  mounted: function mounted() {
    this.loadFoodResources();
    this.isMobile = window.innerWidth < 600;

    this.foodPantryIcon = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.icon);
    this.foodPantryIcon.fillColor = '#0040FF'; // blue

    this.schoolMealsIcon = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.icon);
    this.schoolMealsIcon.fillColor = '#ff0000'; // red

    this.restaurantIcon = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.icon);
    this.restaurantIcon.fillColor = '#009933'; // green

    this.discountGroceryIcon = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.icon);
    this.discountGroceryIcon.fillColor = '#990099'; // purple,
  },
  watch: {},
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['loadFoodResources']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    clearAll: function clearAll() {
      this.typeSelected = [];
      this.filterSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function setLocation(lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this2 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this2.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this3 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_2_ramda___default.a.find(function (p) {
          return p.id === _this3.selectedItem.id;
        })(this.filteredItems);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this4 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_2_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_2_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this4.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this4.subStatusesSelected.splice(i, 1);
        }
      });
    },
    getLocation: function getLocation(item) {
      var location = item['Organization'];

      location += item['Co-Sponsor'] !== null ? ' with ' + item['Co-Sponsor'] : '';

      location += item['Organization'] !== item['Location name'] ? ' at ' + item['Location name'] : '';

      return location;
    },

    ageRestrictionChange: function ageRestrictionChange(ev) {
      if (this.filterSelected.includes('age_restriction')) {
        this.filterSelected.push('Age restrictions - for children (or families of children) only');
        this.filterSelected.push('Age restrictions - for seniors only');
      } else {
        this.filterSelected.splice(this.filterSelected.indexOf('Age restrictions - for children (or families of children) only'), 1);
        this.filterSelected.splice(this.filterSelected.indexOf('Age restrictions - for seniors only'), 1);
      }
    }
  })
});

/***/ }),

/***/ "UmO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ramda__);




/* harmony default export */ __webpack_exports__["a"] = ({
  loadApartments: function loadApartments() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://datahub-v2.arlingtonva.us/api/Location/ApartmentCondoComplex?$top=10000').then(function (result) {
        var temp = __WEBPACK_IMPORTED_MODULE_2_ramda___default.a.map(function (m) {
          m.id = m.apartmentCondoComplexKey;
          if (!m.id) {
            console.log(m);
          }
          m.lat = parseFloat(m.latitudeCrd);
          m.lng = parseFloat(m.longitudeCrd);
          return m;
        }, result.data);

        resolve(temp);
      });
    });
  }
});

/***/ }),

/***/ "UsWL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__projects_service__ = __webpack_require__("OYSh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      title: 'Test',
      id: this.$route.params.id,
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      zoomLevel: 15,
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        fillColor: '#0040FF',
        fillOpacity: 0.35
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedAssociation: {},
      showCivicAssociations: false,
      permits: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapGetters */])(['projects', 'civicAssociations']), {
    project: function project() {
      var _this = this;

      var project = this.projects.find(function (f) {
        return f.id.toString() === _this.id.toString();
      });
      return project;
    },
    mapCenter: function mapCenter() {
      if (this.project.shapes !== undefined && this.project.shapes['0']) {
        var shape = this.project.shapes['0'];
        if (shape.shape !== 'marker') {
          var c = __WEBPACK_IMPORTED_MODULE_2_geolib___default.a.getCenter(shape.coordinates);
          return { lat: Number(c.latitude), lng: Number(c.longitude) };
        } else {
          return shape.coordinates;
        }
      }
      return this.center;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])(['loadProjects', 'loadCivicAssociations']), {
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedAssociation = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedAssociation = {};
      this.selectedInfoWindowPosition = null;
    },
    loadPermits: function loadPermits() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__projects_service__["a" /* default */].loadPermitsForProject(this.project).then(function (permits) {
        _this2.permits = permits;
      });
    }
  }),
  created: function created() {
    this.loadProjects();
    this.loadCivicAssociations();
  },
  mounted: function mounted() {
    this.loadPermits();
  },

  watch: {
    project: function project() {
      if (!this.project) {
        return [];
      } else {
        this.loadPermits();
      }
    }
  },
  filters: {
    defaultDate: function defaultDate(value) {
      if (value) {
        return __WEBPACK_IMPORTED_MODULE_3_moment___default()(String(value)).format('MM/DD/YYYY');
      }
    }
  }
});

/***/ }),

/***/ "V7lC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__ = __webpack_require__("UsWL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc37fbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__ = __webpack_require__("y/ug");
function injectStyle (ssrContext) {
  __webpack_require__("7dF+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Project_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc37fbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Project_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VBqx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parksAccessibility_vue__ = __webpack_require__("kwJ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d7c36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_parksAccessibility_vue__ = __webpack_require__("nbSo");
function injectStyle (ssrContext) {
  __webpack_require__("qNrQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c6d7c36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_parksAccessibility_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c6d7c36_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_parksAccessibility_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VTGJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__("O56c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcd66fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__("d8Hn");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bcd66fda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WwIL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XfTt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon printer-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M18,3H6V7H18M19,12C18.45,12 18,11.55 18,11C18,10.45 18.45,10 19,10C19.55,10 20,10.45 20,11C20,11.55 19.55,12 19,12M16,19H8V14H16M19,8H5C3.34,8 2,9.34 2,11V17H6V21H18V17H22V11C22,9.34 20.66,8 19,8Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1269c417_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("OcEu");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1269c417_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Home__ = __webpack_require__("h6qm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_apartments_Apartments__ = __webpack_require__("zXeE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_digitalResources_digitalResources__ = __webpack_require__("DBvs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_childCarePrograms_childCarePrograms__ = __webpack_require__("JpvA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_parksAccessibility_parksAccessibility__ = __webpack_require__("VBqx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_foodResources_foodResources__ = __webpack_require__("7z6R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_strapi_map__ = __webpack_require__("y+uY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_projects_Projects__ = __webpack_require__("Kdw1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_projects_Project__ = __webpack_require__("V7lC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pollingPlaces_Polling__ = __webpack_require__("vJcH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_projects_Search__ = __webpack_require__("VTGJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_NotFound__ = __webpack_require__("YcJa");















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home_Home__["a" /* default */]
  }, {
    path: '/apartments',
    name: 'Apartments',
    component: __WEBPACK_IMPORTED_MODULE_3__components_apartments_Apartments__["a" /* default */]
  }, {
    path: '/digitalresources',
    name: 'digitalResources',
    component: __WEBPACK_IMPORTED_MODULE_4__components_digitalResources_digitalResources__["a" /* default */]
  }, {
    path: '/childcareprograms',
    name: 'childcareprograms',
    component: __WEBPACK_IMPORTED_MODULE_5__components_childCarePrograms_childCarePrograms__["a" /* default */]
  }, {
    path: '/parkaccessibility',
    name: 'parkaccessibility',
    component: __WEBPACK_IMPORTED_MODULE_6__components_parksAccessibility_parksAccessibility__["a" /* default */]
  }, {
    path: '/foodresources',
    name: 'foodresources',
    component: __WEBPACK_IMPORTED_MODULE_7__components_foodResources_foodResources__["a" /* default */]
  }, {
    path: '/map/:slug',
    name: 'map',
    component: __WEBPACK_IMPORTED_MODULE_8__components_strapi_map__["a" /* default */]
  }, {
    path: '/polling',
    name: 'polling',
    component: __WEBPACK_IMPORTED_MODULE_11__components_pollingPlaces_Polling__["a" /* default */]
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_9__components_projects_Projects__["a" /* default */],
    props: function props(route) {
      return {
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      };
    }
  }, {
    path: '/dailywork',
    name: 'DailyWork',
    component: __WEBPACK_IMPORTED_MODULE_9__components_projects_Projects__["a" /* default */],
    props: function props(route) {
      return {
        queryStatus: route.query.status,
        querySubStatus: route.query.subStatus,
        queryProjectType: route.query.type
      };
    }
  }, {
    path: '/projects/:id',
    name: 'Project',
    component: __WEBPACK_IMPORTED_MODULE_10__components_projects_Project__["a" /* default */]
  }, {
    path: '/search/',
    name: 'Projects Search',
    component: __WEBPACK_IMPORTED_MODULE_12__components_projects_Search__["a" /* default */]
  }, {
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_13__components_NotFound__["a" /* default */]
  }]
}));

/***/ }),

/***/ "YcJa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce26269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__ = __webpack_require__("yPNS");
function injectStyle (ssrContext) {
  __webpack_require__("JgPu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3ce26269"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce26269_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_NotFound_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ak0r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon scanner-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M4.2,10.7L19.8,5L20.5,6.9L6.4,12H19C20.1,12 21,12.9 21,14V18C21,19.1 20.1,20 19,20H5C3.9,20 3,19.1 3,18V12.5C3,11.7 3.5,10.9 4.2,10.7M17,17H19V15H17V17M5,17H15V15H5V17Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bOdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/apartments"}},[_vm._v(" Apartments & Condos")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                Filters and Location\n                "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                            "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Apartment',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Apartment')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Apartment',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Apartment")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Condominium',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Condominium')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Condominium',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Condo")])])])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Civic Association")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.civicAssocationsSelected),expression:"civicAssocationsSelected"}],attrs:{"id":"civicAssociation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.civicAssocationsSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a civic association")]),_vm._v(" "),_vm._l((_vm.civicAssociations),function(ca){return _c('option',{key:ca.OBJECTID,domProps:{"value":ca}},[_vm._v(_vm._s(ca.LABEL))])})],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.civicAssociationFailure),expression:"civicAssociationFailure"}]},[_vm._v("Unable to load Civic Assocations.")])]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"filter-header",on:{"click":_vm.getCurrentLocation}},[_vm._v("Your Current Location")])]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[_vm._l((_vm.filteredApartments),function(apartment){return _c('gmap-marker',{key:apartment.id,attrs:{"position":apartment,"icon":_vm.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(apartment, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('div',{staticClass:"info-window"},[_c('b',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.complexName)}}),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem.complexTypeName))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem.complexStreetNbrNameText))]),_vm._v(" "),(_vm.selectedItemCivic)?_c('span',[_c('br'),_c('br'),_vm._v("\n                          Within the "),_c('b',[_vm._v(_vm._s(_vm.selectedItemCivic.civicAssociationName))]),_vm._v(" civic association.\n                          "),_c('br'),_vm._v("\n                          "+_vm._s(_vm.selectedItemCivic.contactTitleName)+" - "+_vm._s(_vm.selectedItemCivic.contactName)+" "),_c('br'),_vm._v("\n                          "+_vm._s(_vm.selectedItemCivic.firstContactEmailText)+"\n                        ")]):_vm._e()])]),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredApartments),function(apartment){return _c('div',{key:apartment.id,staticClass:"project"},[_c('h3',{domProps:{"innerHTML":_vm._s(apartment.complexName)}}),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_vm._v(_vm._s(apartment.complexTypeName))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(apartment.complexStreetNbrNameText))]),_vm._v(" "),_c('br')])])}),0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p'),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8Hn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington - Projects Search")])],1)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Search Projects")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"index","id":"search"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane"},[_c('ul',_vm._l((_vm.filteredProjects),function(project){return _c('li',{key:project.id},[_c('a',{attrs:{"href":'/projects/' + project.id}},[_vm._v(_vm._s(project.title))])])}),0)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n                    Search for projects\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ePK3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/childcareprograms"}},[_vm._v(" Child Care Availability")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                Filters and Location\n                "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                            "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Child Care Availability")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'ChildCare',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'ChildCare')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='ChildCare',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'FamilyCare',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'FamilyCare')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='FamilyCare',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_vm._m(2)]),_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Program Status")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Status-Open',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Status-Open')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Status-Open',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Open")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Status-Closed',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Status-Closed')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Status-Closed',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Closed")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Available-Slots',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Available-Slots')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Available-Slots',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Available slots")])]),_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Language")]),_vm._v(" "),_c('div',{staticClass:"language-grouping"},[_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'amha',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'amha')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='amha',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Amharic")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'arab',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'arab')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='arab',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Arabic")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'beng',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'beng')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='beng',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Bengali")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'engl',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'engl')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='engl',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" English")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'fars',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'fars')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='fars',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Farsi")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'fren',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'fren')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='fren',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" French")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'hind',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'hind')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='hind',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Hindi")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'limi',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'limi')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='limi',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Limi")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'othe',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'othe')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='othe',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Other")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'punj',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'punj')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='punj',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Punjabi")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'span',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'span')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='span',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Spanish")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'tigr',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'tigr')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='tigr',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Tigre")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.languageSelected),expression:"languageSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'urdu',"checked":Array.isArray(_vm.languageSelected)?_vm._i(_vm.languageSelected,'urdu')>-1:(_vm.languageSelected)},on:{"change":function($event){var $$a=_vm.languageSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='urdu',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.languageSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.languageSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.languageSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Urdu")])])]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category",staticStyle:{"padding-top":"15px"}},[_vm._v("Other")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'AcceptChildCareSubsidy',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'AcceptChildCareSubsidy')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='AcceptChildCareSubsidy',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Participates in Child Care Subsidy\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'AcceptVirginiaQuality',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'AcceptVirginiaQuality')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='AcceptVirginiaQuality',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Participates in Virginia Quality\n                            ")])]),_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchProvider),expression:"searchProvider"}],attrs:{"placeholder":"Search By Provider","type":"text"},domProps:{"value":(_vm.searchProvider)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchProvider=$event.target.value}}})])])]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[_vm._l((_vm.filteredItems),function(item){return _c('gmap-marker',{key:item.name,attrs:{"position":item,"icon":item.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(item, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('div',{staticClass:"info-window"},[_c('h3',{staticClass:"info-window-header"},[_c('b',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.name)}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem['Street Address']))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem['Phone Number']))]),_c('br'),_vm._v(" "),(_vm.selectedItem['Website'] && _vm.selectedItem['Website'] != 'N/A')?_c('span',[_c('a',{attrs:{"target":"_blank","href":_vm.selectedItem['Website']}},[_vm._v("Website")]),_c('br')]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.selectedItem['contact'] && _vm.selectedItem['contact'] != 'N/A')?_c('span',[_c('b',[_vm._v("Contact Person:")]),_vm._v(" "+_vm._s(_vm.selectedItem['contact'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Program Status\r\nOpen/Closed'] && _vm.selectedItem['Program Status\r\nOpen/Closed'] != 'N/A')?_c('span',[_c('b',[_vm._v("Program Status:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Program Status\r\nOpen/Closed'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['# of Current \r\nAvailable Slots'] && _vm.selectedItem['# of Current \r\nAvailable Slots'] != 'N/A')?_c('span',[_c('b',[_vm._v("# of Available Slots:")]),_vm._v(" "+_vm._s(_vm.selectedItem['# of Current \r\nAvailable Slots'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Age(s) of \r\nAvailable Slots'] && _vm.selectedItem['Age(s) of \r\nAvailable Slots'] != 'N/A')?_c('span',[_c('b',[_vm._v("Age(s): of Available Slots")]),_vm._v(" "+_vm._s(_vm.selectedItem['Age(s) of \r\nAvailable Slots'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Accepts Child Care Subsidy'] && _vm.selectedItem['Accepts Child Care Subsidy'] != 'N/A')?_c('span',[_c('b',[_vm._v("Participates in Child Care Subsidy:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Accepts Child Care Subsidy'] == 0 ? 'No' : 'Yes')),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Language'] && _vm.selectedItem['Language'] != 'N/A')?_c('span',[_c('b',[_vm._v("Language:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Language'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Participates in Virginia Quality'] && _vm.selectedItem['Participates in Virginia Quality'] != 'N/A')?_c('span',[_c('b',[_vm._v("Participates in Virginia Quality:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Participates in Virginia Quality'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Notes'] && _vm.selectedItem['Notes'] != 'N/A')?_c('span',[_c('b',[_vm._v("Notes:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Notes'])),_c('br')]):_vm._e()])]),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredItems),function(item){return _c('div',{key:item.Facility,staticClass:"project"},[_c('div',[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"h3-list"},[_c('b',{domProps:{"innerHTML":_vm._s(item.name)}})])]),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_vm._v(_vm._s(item['Street Address']))]),_vm._v(" "),(item['Phone Number'])?_c('span',[_c('br'),_vm._v(_vm._s(item['Phone Number']))]):_vm._e(),_c('br'),_vm._v(" "),(item['Website'] && item['Website'] != 'N/A')?_c('span',[_c('a',{attrs:{"target":"_blank","href":item['Website']}},[_vm._v("Website")]),_c('br')]):_vm._e()]),_c('br'),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[(item['contact'] && item['contact'] != 'N/A')?_c('span',[_c('b',[_vm._v("Contact Person:")]),_vm._v(" "+_vm._s(item['contact'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Program Status\r\nOpen/Closed'] && item['Program Status\r\nOpen/Closed'] != 'N/A')?_c('span',[_c('b',[_vm._v("Program Status:")]),_vm._v(" "+_vm._s(item['Program Status\r\nOpen/Closed'])),_c('br')]):_vm._e(),_vm._v(" "),(item['# of Current \r\nAvailable Slots'] && item['# of Current \r\nAvailable Slots'] != 'N/A')?_c('span',[_c('b',[_vm._v("# of Available Slots:")]),_vm._v(" "+_vm._s(item['# of Current \r\nAvailable Slots'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Age(s) of \r\nAvailable Slots'] && item['Age(s) of \r\nAvailable Slots'] != 'N/A')?_c('span',[_c('b',[_vm._v("Age(s) of Available Slots:")]),_vm._v(" "+_vm._s(item['Age(s) of \r\nAvailable Slots'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Accepts Child Care Subsidy'] && item['Accepts Child Care Subsidy'] != 'N/A')?_c('span',[_c('b',[_vm._v("Participates in Child Care Subsidy:")]),_vm._v(" "+_vm._s(item['Accepts Child Care Subsidy'] == 0 ? 'No' : 'Yes')),_c('br')]):_vm._e(),_vm._v(" "),(item['Language'] && item['Language'] != 'N/A')?_c('span',[_c('b',[_vm._v("Language:")]),_vm._v(" "+_vm._s(item['Language'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Participates in Virginia Quality'] && item['Participates in Virginia Quality'] != 'N/A')?_c('span',[_c('b',[_vm._v("Participates in Virginia Quality:")]),_vm._v(" "+_vm._s(item['Participates in Virginia Quality'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Notes'] && item['Notes'] != 'N/A')?_c('span',[_c('b',[_vm._v("Notes:")]),_vm._v(" "+_vm._s(item['Notes'])),_c('br')]):_vm._e()])])])}),0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n              These are the most up-to-date listings of child care in Arlington. Open spots may be prioritized for first responders and other essential workers. Contact providers for details.\n          ")]),_vm._v(" "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Child Care Center\n                              "),_c('span',{staticClass:"box red"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tooltip"},[_vm._v(" Family Day Care\n                              "),_c('span',{staticClass:"box blue"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "f3QL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon subway-variant-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M18,11H13V6H18M16.5,17C15.67,17 15,16.33 15,15.5C15,14.67 15.67,14 16.5,14C17.33,14 18,14.67 18,15.5C18,16.33 17.33,17 16.5,17M11,11H6V6H11M7.5,17C6.67,17 6,16.33 6,15.5C6,14.67 6.67,14 7.5,14C8.33,14 9,14.67 9,15.5C9,16.33 8.33,17 7.5,17M12,2C7.58,2 4,2.5 4,6V15.5C4,17.43 5.57,19 7.5,19L6,20.5V21H18V20.5L16.5,19C18.43,19 20,17.43 20,15.5V6C20,2.5 16.42,2 12,2Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h6qm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("owUo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed3f0c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("2SY2");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ed3f0c5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hzdq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_printer_vue__ = __webpack_require__("1Bzr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5233ad34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_printer_vue__ = __webpack_require__("XfTt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_printer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5233ad34_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_printer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ifW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kK5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bus-icon",
  props: {
    title: {
      type: String,
      default: "Bus icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "kwJ1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'parkAccessibility',
  data: function data() {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      amenityFilter: false,
      accessibilityFilter: false,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      trailsFilter: ['Gravel', 'Mixed', 'Natural', 'Paved'],
      trailsFilterSelected: [],
      playAreaFilter: ['Fenced in', 'Not Fenced in', 'Partially Fenced'],
      playAreaFilterSelected: [],
      groundCoverFilter: ['Asphalt', 'Astroturf', 'Concrete', 'Dirt', 'Grass', 'Mulch', 'Rubber Turf', 'Sand', 'Wood Chips'],
      groundCoverFilterSelected: [],
      playGroundCoverFilter: ['Asphalt', 'Concrete', 'Engineered Wood Fiber', 'Natural', 'Paved', 'Sand', 'Synthetic Playground Turf', 'Wood Chips'],
      playGroundCoverFilterSelected: [],
      sunCoverFilter: ['Covered pavillion', 'Gazebo', 'Indoor Facility', 'Limited/variable sun cover', 'No sun cover'],
      sunCoverFilterSelected: [],
      parkAccessFilter: ['No paved access to play area(s)', 'Paved sidewalk access', 'Ramp and stair access', 'Stairs', 'Stairs to trail', 'Stairs w/ bridge', 'Unpaved access'],
      parkAccessFilterSelected: [],
      proximityFilter: ['Adjacent to fields', 'Located with center/school', 'Isolated from roads', 'Next to main road/side road', 'Next to residences/buildings', 'Varies: trail crossings and some road crossings'],
      proximityFilterSelected: [],
      pondFilter: ['Access to Pond/Stream', 'No access to Pond/Stream'],
      pondFilterSelected: [],
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['parkAccessibilities']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      return this.center;
    },
    filteredItems: function filteredItems() {
      var _pa = this.parkAccessibilities;
      console.log(_pa);

      if (this.typeSelected.includes('parking')) {
        _pa = _pa.filter(function (f) {
          return f.parking;
        });
      }
      if (this.typeSelected.includes('restroom')) {
        _pa = _pa.filter(function (f) {
          return f.restroom;
        });
      }
      if (this.typeSelected.includes('seating')) {
        _pa = _pa.filter(function (f) {
          return f.seats;
        });
      }
      if (this.typeSelected.includes('freshwater')) {
        _pa = _pa.filter(function (f) {
          return f.freshwater;
        });
      }
      if (this.typeSelected.includes('playarea')) {
        _pa = _pa.filter(function (f) {
          return f.playarea;
        });
      }

      _pa = this.checkFilter(_pa, this.trailsFilterSelected, 'trails');
      _pa = this.checkFilter(_pa, this.playAreaFilterSelected, 'Park/Play Area Perimeter');
      _pa = this.checkFilter(_pa, this.groundCoverFilterSelected, 'ground cover (laymans)');
      _pa = this.checkFilter(_pa, this.playGroundCoverFilterSelected, 'Play/Surface Ground Cover');
      _pa = this.checkFilter(_pa, this.sunCoverFilterSelected, 'Access to Sun Cover');
      _pa = this.checkFilter(_pa, this.proximityFilterSelected, 'Proximity to Roads');
      _pa = this.checkFilter(_pa, this.pondFilterSelected, 'Fresh Water on Site');

      if (this.parkAccessFilterSelected && this.parkAccessFilterSelected.length > 0) {
        var parkAccessFilterSelected = this.parkAccessFilterSelected.map(function (x) {
          return x.toLowerCase();
        });
        _pa = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(_pa, function (f) {
          if (f['Play/Park Access']) {
            for (var i = 0; i < parkAccessFilterSelected.length; i++) {
              // edge conditions
              if (parkAccessFilterSelected[i] === 'stairs to trail') {
                return f['Play/Park Access'] === 'stairway to custis trail' || f['Play/Park Access'] === 'stairs to paved trail';
              }
              var included = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(f['Play/Park Access'].toLowerCase(), parkAccessFilterSelected[i]);
              if (included) {
                return true;
              }
            }
          } else {
            return false;
          }
        });
      }
      return _pa;
    }
  }),
  mounted: function mounted() {
    this.loadParkAccessibilities();

    this.isMobile = window.innerWidth < 600;
  },
  watch: {
    statusesSelected: function statusesSelected() {
      this.infoWindowCheck();
    },
    projectTypesSelected: function projectTypesSelected() {
      this.infoWindowCheck();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['loadParkAccessibilities']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    checkFilter: function checkFilter(items, filterSelected, itemProp) {
      var filtered = items;
      if (filterSelected && filterSelected.length > 0) {
        var _filterSelected = filterSelected.map(function (x) {
          return x.toLowerCase();
        });
        filtered = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.filter(items, function (f) {
          if (f[itemProp]) {
            for (var i = 0; i < _filterSelected.length; i++) {
              var included = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.includes(f[itemProp].toLowerCase(), _filterSelected[i]);
              // edge case for same wording
              if (included && _filterSelected[i] === 'access to pond/stream') {
                if (f[itemProp].toLowerCase().indexOf('no') >= 0) {
                  return false;
                } else {
                  return true;
                }
              } else if (included) {
                return true;
              }
            }
          } else {
            return false;
          }
        });
      }
      return filtered;
    },
    clearAll: function clearAll() {
      this.typeSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
      this.radiusSelected = '';
      this.trailsFilterSelected = [];
      this.playAreaFilterSelected = [];
      this.groundCoverFilterSelected = [];
      this.playGroundCoverFilterSelected = [];
      this.sunCoverFilterSelected = [];
      this.parkAccessFilterSelected = [];
      this.proximityFilterSelected = [];
      this.pondFilterSelected = [];
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    setLocation: function setLocation(lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this2 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.find(function (p) {
          return p.id === _this2.selectedItem.id;
        })(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this3 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this3.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this3.subStatusesSelected.splice(i, 1);
        }
      });
    },
    openLink: function openLink(link) {
      window.open(link, '_blank');
    }
  })
});

/***/ }),

/***/ "lpVE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nbSo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/parkaccessibility"}},[_vm._v(" Filter Park Amenities & Accessible Features to Find a Park that Fits your Needs")])],1),_vm._v(" "),_c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n                Everyone, everywhere, every day: access for all! That�s the Arlington way. We are not only striving to meet "),_c('a',{attrs:{"target":"_blank","href":"https://www.access-board.gov/guidelines-and-standards/buildings-and-sites/about-the-ada-standards#:~:text=The%20ADA%20Standards%20establish%20design,state%20and%20local%20government%20facilities."}},[_vm._v("ADA Standards")]),_vm._v(", we want to do more. Use this form to filter the amenities and accessible features in our parks to find the ones that meet your needs. \n                "),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("How to use: ")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("You can filter by any combination of amenities or accessible features by clicking on the plus icon to expand the options. Select as many as you would like by checking the box next to each option. The results will update automatically based on each amenity or accessible feature you select/deselect. ")]),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Viewing Results: ")]),_c('br'),_vm._v(" "),_c('span',[_vm._v("You can view your filter results in map or list form. Click on the Map or List text above the map. To view the details of a park, click on the blue location icon(s) on the map.  ")]),_c('br'),_c('br'),_vm._v("\n                To request a correction, fill out this "),_c('a',{attrs:{"href":"https://parks.arlingtonva.us/park-accessibility-correction-request/","target":"_blank"}},[_vm._v("form")]),_vm._v(".\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                  Filters and Location\n                  "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":function($event){_vm.amenityFilter = !_vm.amenityFilter}}},[_c('span',[_vm._v("Amenity\n                              "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.amenityFilter),expression:"amenityFilter"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.amenityFilter),expression:"!amenityFilter"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),(!_vm.amenityFilter)?_c('br'):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.amenityFilter || _vm.mobileMenu),expression:"amenityFilter || mobileMenu"}],staticClass:"filterList"},[_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'parking',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'parking')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='parking',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Parking")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'restroom',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'restroom')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='restroom',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Restroom")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'seating',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'seating')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='seating',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Seating")])]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'playarea',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'playarea')>-1:(_vm.typeSelected)},on:{"change":function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='playarea',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" Play Area")])]),_c('br')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":function($event){_vm.accessibilityFilter = !_vm.accessibilityFilter}}},[_c('span',[_vm._v("Accessible Features\n                              "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessibilityFilter),expression:"accessibilityFilter"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.accessibilityFilter),expression:"!accessibilityFilter"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessibilityFilter || _vm.mobileMenu),expression:"accessibilityFilter || mobileMenu"}],staticClass:"filterList"},[_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Trails")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.trailsFilter,"outline":"","dense":true,"height":"20px","multiple":"","hint":"Select a surface"},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.trailsFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.trailsFilterSelected),callback:function ($$v) {_vm.trailsFilterSelected=$$v},expression:"trailsFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Fenced In")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.playAreaFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.playAreaFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.playAreaFilterSelected),callback:function ($$v) {_vm.playAreaFilterSelected=$$v},expression:"playAreaFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Play Surface Material")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.playGroundCoverFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.playGroundCoverFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.playGroundCoverFilterSelected),callback:function ($$v) {_vm.playGroundCoverFilterSelected=$$v},expression:"playGroundCoverFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Access to Sun Cover")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.sunCoverFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.sunCoverFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.sunCoverFilterSelected),callback:function ($$v) {_vm.sunCoverFilterSelected=$$v},expression:"sunCoverFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Play/Park Access")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.parkAccessFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.parkAccessFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.parkAccessFilterSelected),callback:function ($$v) {_vm.parkAccessFilterSelected=$$v},expression:"parkAccessFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Proximity to Roads")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.proximityFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.proximityFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.proximityFilterSelected),callback:function ($$v) {_vm.proximityFilterSelected=$$v},expression:"proximityFilterSelected"}})],1)],1),_vm._v(" "),_c('div',[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Access to Pond/Stream")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","d-flex":""}},[_c('v-select',{attrs:{"items":_vm.pondFilter,"outline":"","dense":true,"height":"20","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [(index === 0 && item.length > 14)?_c('span',[_vm._v(_vm._s(item.substring(0,14) + "..")+"   ")]):_vm._e(),_vm._v(" "),(index === 0 && item.length <= 14)?_c('span',[_vm._v(_vm._s(item)+"   ")]):_vm._e(),_vm._v(" "),(index === 1)?_c('span',{staticClass:"grey--text caption"},[_vm._v("\n                                    (+"+_vm._s(_vm.pondFilterSelected.length - 1)+" others)\n                                  ")]):_vm._e()]}}]),model:{value:(_vm.pondFilterSelected),callback:function ($$v) {_vm.pondFilterSelected=$$v},expression:"pondFilterSelected"}})],1)],1)])]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[_vm._l((_vm.filteredItems),function(item){return _c('gmap-marker',{key:item.name,attrs:{"position":item,"icon":_vm.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(item, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('div',{staticClass:"info-window"},[_c('h3',{staticClass:"info-window-header"},[_c('b',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.Park)}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem['Address']))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.selectedItem['Parking Access'])?_c('span',[_c('b',[_vm._v("Parking Access:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Parking Access'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Restroom Access'])?_c('span',[_c('b',[_vm._v("Restroom Access:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Restroom Access'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Park/Play Area Perimeter'])?_c('span',[_c('b',[_vm._v("Park/Play Area Perimeter:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Park/Play Area Perimeter'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Play/Park Access'])?_c('span',[_c('b',[_vm._v("Park/Play Access:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Play/Park Access'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['accessible playground equip.'])?_c('span',[_c('b',[_vm._v("Accessible Playground Equipment:")]),_vm._v(" "+_vm._s(_vm.selectedItem['accessible playground equip.'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Play/Surface Ground Cover'])?_c('span',[_c('b',[_vm._v("Play Surface Material:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Play/Surface Ground Cover'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Access to Sun Cover'])?_c('span',[_c('b',[_vm._v("Access to Sun Cover:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Access to Sun Cover'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Proximity to Roads'])?_c('span',[_c('b',[_vm._v("Proximity to Roads:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Proximity to Roads'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['seating'])?_c('span',[_c('b',[_vm._v("Seating:")]),_vm._v(" "+_vm._s(_vm.selectedItem['seating'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Fresh Water on Site'] && _vm.selectedItem['Fresh Water on Site'] != 'n/a')?_c('span',[_c('b',[_vm._v("Pond/Stream:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Fresh Water on Site'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Play Area on Site'] && _vm.selectedItem['Play Area on Site'] != 'N/A')?_c('span',[_c('b',[_vm._v("Play Area on Site:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Play Area on Site'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['trails'] && _vm.selectedItem['trails'] != 'N/A')?_c('span',[_c('b',[_vm._v("Trails:")]),_vm._v(" "+_vm._s(_vm.selectedItem['trails'])),_c('br')]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.openLink(_vm.selectedItem['URL'])}}},[_vm._v("View Full Park Details")])])]),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredItems),function(item){return _c('div',{key:item.Facility,staticClass:"project"},[_c('div',[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"h3-list"},[_c('b',{domProps:{"innerHTML":_vm._s(item.Park)}})])]),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_vm._v(_vm._s(item['Address']))]),_c('br')]),_c('br'),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[(item['Parking Access'])?_c('span',[_c('b',[_vm._v("Parking Access:")]),_vm._v(" "+_vm._s(item['Parking Access'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Park/Play Area Perimeter'])?_c('span',[_c('b',[_vm._v("Park/Play Area Perimeter:")]),_vm._v(" "+_vm._s(item['Park/Play Area Perimeter'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Play/Park Access'])?_c('span',[_c('b',[_vm._v("Park/Play Access:")]),_vm._v(" "+_vm._s(item['Play/Park Access'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Restroom Access'])?_c('span',[_c('b',[_vm._v("Restroom Access:")]),_vm._v(" "+_vm._s(item['Restroom Access'])),_c('br')]):_vm._e(),_vm._v(" "),(item['accessible playground equip.'])?_c('span',[_c('b',[_vm._v("Accessible Playground Equipment:")]),_vm._v(" "+_vm._s(item['accessible playground equip.'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Play/Surface Ground Cover'])?_c('span',[_c('b',[_vm._v("Play Surface Material:")]),_vm._v(" "+_vm._s(item['Play/Surface Ground Cover'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Access to Sun Cover'])?_c('span',[_c('b',[_vm._v("Access to Sun Cover:")]),_vm._v(" "+_vm._s(item['Access to Sun Cover'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Proximity to Roads'])?_c('span',[_c('b',[_vm._v("Proximity to Roads:")]),_vm._v(" "+_vm._s(item['Proximity to Roads'])),_c('br')]):_vm._e(),_vm._v(" "),(item['seating'])?_c('span',[_c('b',[_vm._v("Seating:")]),_vm._v(" "+_vm._s(item['seating'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Fresh Water on Site'] && item['Fresh Water on Site'] != 'n/a')?_c('span',[_c('b',[_vm._v("Pond/Stream:")]),_vm._v(" "+_vm._s(item['Fresh Water on Site'])),_c('br')]):_vm._e(),_vm._v(" "),(item['Play Area on Site'] && item['Play Area on Site'] != 'N/A')?_c('span',[_c('b',[_vm._v("Play Area on Site:")]),_vm._v(" "+_vm._s(item['Play Area on Site'])),_c('br')]):_vm._e(),_vm._v(" "),(item['trails'] && item['trails'] != 'N/A')?_c('span',[_c('b',[_vm._v("Trails:")]),_vm._v(" "+_vm._s(item['trails'])),_c('br')]):_vm._e(),_vm._v(" "),_c('a',{on:{"click":function($event){return _vm.openLink(item['URL'])}}},[_vm._v("View Full Park Details")])])])])}),0)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "owUo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "pq0S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_desktop_classic_vue__ = __webpack_require__("tRzg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_637c510a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_desktop_classic_vue__ = __webpack_require__("9O9T");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_desktop_classic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_637c510a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_desktop_classic_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63e0e108_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("ifW/");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_63e0e108_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qNrQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rNJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/foodResources"}},[_vm._v(" "+_vm._s(_vm.metadata.Title))])],1),_vm._v(" "),(_vm.ready)?_c('div',{attrs:{"id":"blurb"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.markdownToHtml)}}),_vm._v(" "),_c('br')]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                Filters and Location\n                "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                            "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_vm._l((_vm.metadata.FilterCategory),function(category,index){return _c('div',{key:index},[_c('div',{staticClass:"filter-item filter-category"},[_vm._v("\n                          "+_vm._s(category.Label)+"\n                        ")]),_vm._v(" "),_vm._l((category.Filters),function(filterItem){return _c('div',{key:filterItem.Label,staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":category.Label + ':' + filterItem.Field + ':' + filterItem.Value,"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,category.Label + ':' + filterItem.Field + ':' + filterItem.Value)>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=category.Label + ':' + filterItem.Field + ':' + filterItem.Value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" "+_vm._s(filterItem.Label)+"\n                            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.BoxIcon),expression:"filterItem.BoxIcon"}],class:"box " + filterItem.BoxIcon}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.Tooltip),expression:"filterItem.Tooltip"}],staticClass:"tooltiptext"},[_vm._v(_vm._s(filterItem.Tooltip))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.class),expression:"filterItem.class"}],class:filterItem.Icon}),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(filterItem.Icon),expression:"filterItem.Icon"}]},[_vm._v(_vm._s(filterItem.Icon))])],1)])}),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((category.PrecinctFilters),function(filterItem){return _c('div',{key:filterItem.Label,staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterSelected),expression:"filterSelected"}],attrs:{"type":"checkbox"},domProps:{"value":category.Label + ':' + filterItem.Field + ':' + filterItem.Value,"checked":Array.isArray(_vm.filterSelected)?_vm._i(_vm.filterSelected,category.Label + ':' + filterItem.Field + ':' + filterItem.Value)>-1:(_vm.filterSelected)},on:{"change":function($event){var $$a=_vm.filterSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=category.Label + ':' + filterItem.Field + ':' + filterItem.Value,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.filterSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.filterSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.filterSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_vm._v(" "+_vm._s(filterItem.Label)+"\n                            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.BoxIcon),expression:"filterItem.BoxIcon"}],class:"box " + filterItem.BoxIcon}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.Tooltip),expression:"filterItem.Tooltip"}],staticClass:"tooltiptext"},[_vm._v(_vm._s(filterItem.Tooltip))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(filterItem.class),expression:"filterItem.class"}],class:filterItem.Icon}),_vm._v(" "),_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(filterItem.Icon),expression:"filterItem.Icon"}]},[_vm._v(_vm._s(filterItem.Icon))])],1),_vm._v(" "),_c('hr',{directives:[{name:"show",rawName:"v-show",value:(_vm.metadata.FilterCategory.length >index+1),expression:"metadata.FilterCategory.length >index+1"}]}),_vm._v(" "),_c('br')])})],2)})],2)]),_vm._v(" "),(_vm.metadata.CivicAssociationFilter)?_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Civic Association")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.civicAssocationsSelected),expression:"civicAssocationsSelected"}],attrs:{"id":"civicAssociation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.civicAssocationsSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a civic association")]),_vm._v(" "),_vm._l((_vm.civicAssociations),function(ca){return _c('option',{key:ca.OBJECTID,domProps:{"value":ca}},[_vm._v(_vm._s(ca.LABEL))])})],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.civicAssociationFailure),expression:"civicAssociationFailure"}]},[_vm._v("Unable to load Civic Assocations.")])]):_vm._e(),_vm._v(" "),(_vm.metadata.VoterPrecinctFilter)?_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Voter Precinct")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.voterPrecinctSelected),expression:"voterPrecinctSelected"}],attrs:{"id":"voterPrecinct"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.voterPrecinctSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a voter precinct")]),_vm._v(" "),_vm._l((_vm.voterPrecincts),function(ca){return _c('option',{key:ca.OBJECTID,domProps:{"value":ca}},[_vm._v(_vm._s(ca.POLLING_PLACE))])})],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.voterPrecinctFailure),expression:"voterPrecinctFailure"}]},[_vm._v("Unable to load Voter Precincts.")])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),(_vm.metadata.RadiusFilter)?_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"radius"}},[_vm._v("Radius")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.radiusSelected),expression:"radiusSelected"}],attrs:{"id":"radius","disabled":!_vm.selectedCoordinates},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.radiusSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Set distance")]),_vm._v(" "),_c('option',{attrs:{"value":"0.5"}},[_vm._v("0.5 Mile")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Mile")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),(_vm.ready)?_c('div',{staticClass:"widget full-map-pane toggle-window two-thirds"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[(_vm.metadata.Type === 'Pins' || _vm.metadata.Type === 'Both')?_c('div',[_vm._l((_vm.filteredItems),function(item){return _c('gmap-marker',{key:item.location_name,attrs:{"position":item,"icon":item.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(item, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('h3',{staticClass:"info-window-header"},[_c('b',[_vm._v(_vm._s(_vm.selectedItem[_vm.metadata.PinPopupTitle]))])]),_vm._v(" "),_vm._l((_vm.metadata.PinPopupFields.split(',')),function(field,index){return _c('div',{key:index,staticClass:"info-window"},[_c('b',[_vm._v(_vm._s(field.indexOf('=') > 0 ? field.split('=')[1].trim() : field))]),_vm._v(": "+_vm._s(_vm.selectedItem[field.split('=')[0].trim()] || 'N/A')+"\n                      ")])})],2)],2):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e(),_vm._v(" "),(_vm.voterPrecinctSelected)?_c('gmap-polygon',{attrs:{"path":_vm.voterPrecinctSelected.paths,"options":_vm.locationOptions},on:{"click":function (e) { return _vm.layerClick(_vm.voterPrecinctSelected, e); }}}):_vm._e(),_vm._v(" "),(_vm.metadata.Type === 'Layers' || _vm.metadata.Type === 'Both')?_c('div',[_vm._l((_vm.filteredItems),function(layer,index){return _c('gmap-polygon',{key:index,attrs:{"path":layer.paths,"options":layer.options},on:{"click":function (e) { return _vm.layerClick(layer, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedLayerWindowPosition !== null,"position":_vm.selectedLayerWindowPosition},on:{"closeclick":_vm.layerWindowCloseClick}},[_c('h3',{staticClass:"info-window-header"},[_c('b',[_vm._v(_vm._s(_vm.selectedItem[_vm.metadata.LayerPopupTitle]))])]),_vm._v(" "),_vm._l((_vm.metadata.LayerPopupFields.split(',')),function(field,index){return (_vm.metadata.LayerPopupFields)?_c('div',{key:index,staticClass:"info-window"},[_c('b',[_vm._v(_vm._s(field))]),_vm._v(": "+_vm._s(_vm.selectedItem[field.trim()] || 'N/A')+"\n                      ")]):_vm._e()})],2)],2):_vm._e()],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredItems),function(item,index){return _c('div',{key:index,staticClass:"project"},[_c('div',{staticClass:"row"},[_c('h3',{staticClass:"h3-list"},[_c('b',[_vm._v(_vm._s(item[_vm.metadata.ListTitle]))])]),_vm._v(" "),_vm._l((_vm.metadata.ListFields.split(',')),function(field,index){return (_vm.metadata.ListFields)?_c('p',{key:index,staticClass:"no-vertical-margin"},[_c('b',[_vm._v(_vm._s(field.indexOf('=') > 0 ? field.split('=')[1].trim() : field))]),_vm._v(": "+_vm._s(item[field.split('=')[0].trim()] || 'N/A')+"\n                    ")]):_vm._e()})],2)])}),0)],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rmnd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sEt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "wifi-icon",
  props: {
    title: {
      type: String,
      default: "Wifi icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "siN1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "srxD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"material-design-icon wifi-icon",attrs:{"aria-hidden":_vm.decorative,"role":"img","aria-label":_vm.title}},[_c('svg',{staticClass:"material-design-icon__svg",attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":_vm.fillColor}},[_c('title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('path',{attrs:{"d":"M12,21L15.6,16.2C14.6,15.45 13.35,15 12,15C10.65,15 9.4,15.45 8.4,16.2L12,21M12,3C7.95,3 4.21,4.34 1.2,6.6L3,9C5.5,7.12 8.62,6 12,6C15.38,6 18.5,7.12 21,9L22.8,6.6C19.79,4.34 16.05,3 12,3M12,9C9.3,9 6.81,9.89 4.8,11.4L6.6,13.8C8.1,12.67 9.97,12 12,12C14.03,12 15.9,12.67 17.4,13.8L19.2,11.4C17.19,9.89 14.7,9 12,9Z"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "szM1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_wifi_vue__ = __webpack_require__("sEt3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9c74022a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_wifi_vue__ = __webpack_require__("srxD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_wifi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9c74022a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_vue_loader_lib_selector_type_template_index_0_wifi_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tRzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "desktop-classic-icon",
  props: {
    title: {
      type: String,
      default: "Desktop classic icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String
    }
  }
});

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vJcH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Polling_vue__ = __webpack_require__("wUOQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1355ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Polling_vue__ = __webpack_require__("SAZf");
function injectStyle (ssrContext) {
  __webpack_require__("WwIL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b1355ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Polling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b1355ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Polling_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vctp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wUOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places,geocode'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pollingPlaces',
  components: {},
  data: function data() {
    return {
      alert: true,
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      filterQuery: {},
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      radiusSelected: '',
      icon: {
        path: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
        fillColor: '#0040FF', // '#015cb9',
        fillOpacity: 1,
        strokeWeight: 0.5,
        strokeColor: '#fff',
        scale: 1,
        anchor: { x: 14, y: 10 // eslint-disable-line no-undef
        } },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: '',
      typeSelected: [],
      pollingPolygon: '',
      voterPrecincts: [],
      voterPrecinctSelected: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapGetters */])(['']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.voterPrecinctSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }
      if (this.voterPrecinctSelected) {
        var voteCenter = __WEBPACK_IMPORTED_MODULE_4_geolib__["getCenter"](this.voterPrecinctSelected.paths);
        voteCenter.lat = Number(voteCenter.latitude);
        voteCenter.lng = Number(voteCenter.longitude);

        return voteCenter;
      }
      return this.center;
    }
  }),
  beforeMount: function beforeMount() {},
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.isMobile = window.innerWidth < 600;
              _context.next = 3;
              return this.getVoterPrecincts();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  watch: {},
  methods: {
    getVoterPrecincts: function getVoterPrecincts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var items, url, response, columnHeaders;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                /* Map colors */
                items = [];
                url = 'https://arlgis.arlingtonva.us/arcgis/rest/services/Open_Data/od_Voter_Precinct_Polygons/FeatureServer/0/query?outFields=*&where=1%3D1&f=geojson';
                _context2.next = 4;
                return fetch(url).then(function (response) {
                  return response.json();
                });

              case 4:
                response = _context2.sent;
                columnHeaders = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.features[0].properties);

                items.length = 0;

                response.features.forEach(function (voterPrecinct) {
                  var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, voterPrecinct);
                  for (var i = 0; i < columnHeaders.length; i++) {
                    var propertyName = columnHeaders[i];
                    var propertyValue = voterPrecinct.properties[propertyName];
                    item[propertyName] = propertyValue;
                  }

                  item.coordinates = voterPrecinct.geometry.coordinates[0];
                  // Setup google map polygon
                  item.paths = [];
                  item.coordinates.forEach(function (coord) {
                    var latLng = {
                      lng: Number(coord[0]),
                      lat: Number(coord[1])
                    };
                    item.paths.push(latLng);
                  });
                  item.popupInfo = item.PREC_NAME;

                  var options = {};
                  options.strokeColor = voterPrecinct.Color;
                  options.strokeOpacity = 0.8;
                  options.strokeWeight = 2;
                  options.fillColor = voterPrecinct.Color;
                  options.fillOpacity = 0.60;

                  item.options = options;
                  items.push(item);
                });
                _this.voterPrecincts = items.sort(function (a, b) {
                  return a.PREC_NAME.localeCompare(b.PREC_NAME);
                });

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },


    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },

    placeChanged: function placeChanged(place) {
      this.getPrecinct(place.geometry.location.lat(), place.geometry.location.lng());
    },
    getPrecinct: function getPrecinct(lat, lng) {
      var _this2 = this;

      this.voterPrecincts.forEach(function () {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(precinct) {
          var transformedPoints, coord;
          return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  transformedPoints = precinct.paths.map(function (_ref3) {
                    var lat = _ref3.lat,
                        lng = _ref3.lng;
                    return { latitude: lat, longitude: lng };
                  });

                  console.log(precinct);

                  if (!__WEBPACK_IMPORTED_MODULE_4_geolib__["isPointInside"]({ latitude: lat, longitude: lng }, transformedPoints)) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 5;
                  return _this2.getPollingPlaceCoordinates(precinct.ADDRESS);

                case 5:
                  coord = _context3.sent;

                  _this2.setPollingLocation(coord.lat, coord.lng);
                  _this2.voterPrecinctSelected = precinct;

                case 8:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this2);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    getPollingPlaceCoordinates: function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(address) {
        var latlng;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                address += 'Arlington, Virginia';
                latlng = {};
                _context4.next = 4;
                return fetch('https://maps.googleapis.com/maps/api/geocode/json?address=' + address + '&key=AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U').then(function (response) {
                  return response.json();
                }).then(function (data) {
                  latlng.lat = data.results[0].geometry.location.lat;
                  latlng.lng = data.results[0].geometry.location.lng;
                });

              case 4:
                return _context4.abrupt('return', latlng);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getPollingPlaceCoordinates(_x2) {
        return _ref4.apply(this, arguments);
      }

      return getPollingPlaceCoordinates;
    }(),
    setPollingLocation: function setPollingLocation(lat, lng) {
      this.selectedCoordinates = { lat: lat, lng: lng };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this3 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this3.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    infoClick: function infoClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    }
  }
});

/***/ }),

/***/ "wWHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda__ = __webpack_require__("tpu8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ramda___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ramda__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib__ = __webpack_require__("cG/o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDIkJCuWTcYkqhKmKQBKgsFvLJYeZxUu4U',
    libraries: 'places'
  }
});

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projects',
  props: ['queryStatus', 'querySubStatus', 'queryProjectType'],
  data: function data() {
    return {
      isMobile: false,
      showMap: true,
      mobileMenu: null,
      filtersExpanded: true,
      mapStyles: { styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }] },
      statuses: [{
        value: 'Proposed',
        label: 'Proposed',
        subStatuses: [{ value: 'No Status', label: 'No Status' }, { value: 'Preliminary Proposal', label: 'Preliminary Proposal' }, { value: 'Under Review', label: 'Under Review' }, { value: 'Final Submittal', label: 'Final Submittal' }, { value: 'On Hold', label: 'On Hold' }, { value: 'Expired', label: 'Expired' }]
      }, {
        value: 'Approved',
        label: 'Approved',
        subStatuses: [{ value: 'Approved', label: 'Approved' }, { value: 'Planned', label: 'Planned' }, { value: 'In Design', label: 'In Design' }, { value: 'Procurement', label: 'Procurement' }, { value: 'Out to Bid', label: 'Out to Bid' }]
      }, { value: 'Construction', label: 'Construction', subStatuses: [] }, { value: 'Complete', label: 'Complete', subStatuses: [] }],
      statusesSelected: [],
      subStatusesSelected: [],
      projectTypes: [{ value: 'Daily Work', label: 'Daily Work', tooltip: 'Includes County street projects, such as paving and sewer work happening today. Delayed or cancelled projects may still appear on map.' }, { value: 'Environment', label: 'Environment', tooltip: 'Includes stormwater, watershed and streams projects.' }, { value: 'County Facilities', label: 'Facilities', tooltip: 'Includes County facility projects.' }, { value: 'Neighborhood Conservation', label: 'Neighborhood Conservation', tooltip: 'Identifies and provides funding for a variety of neighborhood improvements.' }, { value: 'Parks', label: 'Parks', tooltip: 'Includes parks, fields, courts, playgrounds, shelters and trails.' }, { value: 'Transportation', label: 'Transportation', tooltip: 'Includes bike, pedestrian, street and transit projects.' }, { value: 'Water &amp; Utilities', label: 'Water &amp; Utilities', tooltip: 'Includes water, utility undergrounding, sanitary sewer, communications/cable, stormwater, watershed and streams projects.' }, { value: 'Site Plan Project', label: 'Private Development', tooltip: 'Includes submitted, approved, under construction and recently completed site plan projects.' }],
      projectTypesSelected: ['Daily Work'],
      civicAssocationsSelected: '',
      civicAssociationFailure: false,
      // map properties
      center: {
        lat: 38.8809462,
        lng: -77.099029
      },
      shapeOptions: {
        strokeColor: '#0040FF',
        strokeOpacity: 0.9,
        strokeWeight: 4,
        fillColor: '#0040FF',
        fillOpacity: 0.35,
        zIndex: 2
      },
      locationOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
        zIndex: 1
      },
      addressPinOptions: {
        strokeColor: '#FF0000',
        strokeOpacity: 0.9,
        fillColor: '#FF0000',
        fillOpacity: 0.9
      },
      selectedCoordinates: null,
      selectedInfoWindowPosition: null,
      selectedItem: {},
      searchText: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['projects', 'civicAssociations']), {
    zoomLevel: function zoomLevel() {
      if (!this.selectedCoordinates && !this.civicAssocationsSelected) {
        return 13;
      }
      return 15;
    },
    mapCenter: function mapCenter() {
      if (this.selectedCoordinates) {
        return this.selectedCoordinates;
      }

      if (this.civicAssocationsSelected) {
        var civicCenter = __WEBPACK_IMPORTED_MODULE_2_geolib___default.a.getCenter(this.civicAssocationsSelected.paths);
        civicCenter.lat = Number(civicCenter.latitude);
        civicCenter.lng = Number(civicCenter.longitude);

        return civicCenter;
      }

      return this.center;
    },
    filteredProjects: function filteredProjects() {
      var _this = this;

      var sortByTitle = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.sortBy(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.toLower, __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('title')));
      if (this.projectTypesSelected.length === 0 && this.statusesSelected.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(sortByTitle, __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.filter(function (f) {
          return f.title;
        }))(this.projects);
      }

      var temp = this.projects;

      if (this.statusesSelected.length > 0) {
        temp = temp.filter(function (val, index) {
          return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.contains(val.status, _this.statusesSelected);
        });

        if (this.subStatusesSelected.length > 0) {
          temp = temp.filter(function (val, inex) {
            return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.contains(val.subStatus, _this.subStatusesSelected);
          });
        }
      }

      if (this.projectTypesSelected.length > 0) {
        var projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter(function (val, index) {
          var types = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('name'), val.projects);
          var intersection = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }
      return sortByTitle(temp);
    },
    filteredStatusCount: function filteredStatusCount() {
      var temp = this.projects;

      // filter by only type:
      if (this.projectTypesSelected.length > 0) {
        var projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter(function (val, index) {
          var types = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('name'), val.projects);
          var intersection = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.countBy(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('status'))(temp);
    },
    filteredSubStatusCount: function filteredSubStatusCount() {
      var temp = this.projects;

      // filter by only type:
      if (this.projectTypesSelected.length > 0) {
        var projectTypesSelected = this.projectTypesSelected;
        temp = temp.filter(function (val, index) {
          var types = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('name'), val.projects);
          var intersection = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.intersection(types, projectTypesSelected);
          return intersection.length > 0;
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.countBy(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('subStatus'))(temp);
    },
    filteredTypeCount: function filteredTypeCount() {
      var _this2 = this;

      var temp = this.projects;

      if (this.statusesSelected.length > 0) {
        temp = temp.filter(function (val, index) {
          return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.contains(val.status, _this2.statusesSelected);
        });

        if (this.subStatusesSelected.length > 0) {
          temp = temp.filter(function (val, inex) {
            return __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.contains(val.subStatus, _this2.subStatusesSelected);
          });
        }
      }

      var flat = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.flatten, __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('projects')))(temp);
      var countType = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.countBy(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('name'))(flat);
      return countType;
    }
  }),
  mounted: function mounted() {
    this.loadCivicAssociations();
    this.loadProjects();

    this.isMobile = window.innerWidth < 600;

    if (this.queryStatus) {
      var split = this.queryStatus.split(',');
      this.statusesSelected = split;
      this.filtersExpanded = true;
    }

    if (this.querySubStatus) {
      var statusSplit = this.querySubStatus.split(',');
      this.subStatusesSelected = statusSplit;
      this.filtersExpanded = true;
    }

    if (this.queryProjectType) {
      var projSplit = this.queryProjectType.split(',');
      console.log('Projects', projSplit);
      var joined = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.innerJoin(function (record, label) {
        return record.label === label;
      }, this.projectTypes);
      var values = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'));

      this.projectTypesSelected = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.compose(values, joined)(projSplit);
      this.filtersExpanded = true;
    }
  },
  watch: {
    statusesSelected: function statusesSelected() {
      this.infoWindowCheck();
    },
    projectTypesSelected: function projectTypesSelected() {
      this.infoWindowCheck();
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapActions */])(['loadProjects', 'loadCivicAssociations']), {
    filtersToggle: function filtersToggle() {
      this.filtersExpanded = !this.filtersExpanded;
    },
    clearAll: function clearAll() {
      this.subStatusesSelected = [];
      this.statusesSelected = [];
      this.projectTypesSelected = [];
      this.selectedCoordinates = null;
      this.civicAssocationsSelected = '';
      this.$refs.autocomplete.$refs.input.value = '';
    },

    placeChanged: function placeChanged(place) {
      this.selectedCoordinates = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
    },
    getCurrentLocation: function getCurrentLocation() {
      var _this3 = this;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (pos) {
          _this3.selectedCoordinates = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        }, function (err) {
          alert('Unable to determine current location at this time.');
          return err;
        });
      }
    },
    shapeClick: function shapeClick(item, clickEvent) {
      this.selectedItem = item;
      this.selectedInfoWindowPosition = clickEvent.latLng;
    },
    infoWindowCloseClick: function infoWindowCloseClick() {
      this.selectedItem = {};
      this.selectedInfoWindowPosition = null;
    },
    infoWindowCheck: function infoWindowCheck() {
      var _this4 = this;

      if (this.selectedItem && this.selectedItem.id) {
        var ifCheck = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.find(function (p) {
          return p.id === _this4.selectedItem.id;
        })(this.filteredProjects);
        if (ifCheck === null || ifCheck === undefined) {
          this.selectedItem = {};
          this.selectedInfoWindowPosition = null;
        }
      }
    },
    parentStatusClick: function parentStatusClick(parentStatus) {
      var _this5 = this;

      var statusValues = __WEBPACK_IMPORTED_MODULE_1_ramda___default.a.map(__WEBPACK_IMPORTED_MODULE_1_ramda___default.a.prop('value'), parentStatus.subStatuses);
      statusValues.forEach(function (s) {
        var i = _this5.subStatusesSelected.indexOf(s.value);
        if (i >= 0) {
          _this5.subStatusesSelected.splice(i, 1);
        }
      });
    }
  })
});

/***/ }),

/***/ "wtEF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_projects_projects_service__ = __webpack_require__("OYSh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_apartments_apartments_service__ = __webpack_require__("UmO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_service__ = __webpack_require__("HgH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_digitalResources_digitalResources_service__ = __webpack_require__("MsJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_childCarePrograms_childCarePrograms_service__ = __webpack_require__("/ePW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_foodResources_foodResources_service__ = __webpack_require__("Hcid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_parksAccessibility_parksAccessibility_service__ = __webpack_require__("NBDf");











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  projects: [],
  projectsLoaded: false,
  dailyWorkLoaded: false,
  civicAssociations: [],
  voterPrecincts: [],
  civicInfo: [],
  apartments: [],
  digitalResources: [],
  childCarePrograms: [],
  foodResources: [],
  familyDayCarePrograms: [],
  parkAccessibilities: []
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: {
    projects: function projects(state) {
      return state.projects;
    },
    civicAssociations: function civicAssociations(state) {
      return state.civicAssociations;
    },
    voterPrecincts: function voterPrecincts(state) {
      return state.voterPrecincts;
    },
    apartments: function apartments(state) {
      return state.apartments;
    },
    digitalResources: function digitalResources(state) {
      return state.digitalResources;
    },
    childCarePrograms: function childCarePrograms(state) {
      return state.childCarePrograms;
    },
    familyDayCarePrograms: function familyDayCarePrograms(state) {
      return state.familyDayCarePrograms;
    },
    parkAccessibilities: function parkAccessibilities(state) {
      return state.parkAccessibilities;
    },
    foodResources: function foodResources(state) {
      return state.foodResources;
    }
  },
  actions: {
    loadProjects: function loadProjects(context) {
      if (!this.state.projectsLoaded) {
        __WEBPACK_IMPORTED_MODULE_2__components_projects_projects_service__["a" /* default */].loadProjects().then(function (projects) {
          context.commit('loadProjects', projects);
        });
      }
      if (!this.state.dailyWorkLoaded) {
        __WEBPACK_IMPORTED_MODULE_2__components_projects_projects_service__["a" /* default */].loadDailyWork().then(function (dailyWork) {
          context.commit('loadDailyWork', dailyWork);
        });
      }
    },
    loadCivicAssociations: function loadCivicAssociations(context) {
      if (state.civicAssociations.length === 0) {
        __WEBPACK_IMPORTED_MODULE_4__data_service__["a" /* default */].loadCivicAssociations().then(function (civicAssns) {
          context.commit('loadCivic', civicAssns);
        });
      }
    },
    loadVoterPrecincts: function loadVoterPrecincts(context) {
      if (state.voterPrecincts.length === 0) {
        __WEBPACK_IMPORTED_MODULE_4__data_service__["a" /* default */].loadVoterPrecincts().then(function (voter) {
          context.commit('loadVoterPrecincts', voter);
        });
      }
    },
    loadApartments: function loadApartments(context) {
      if (state.apartments.length === 0) {
        __WEBPACK_IMPORTED_MODULE_3__components_apartments_apartments_service__["a" /* default */].loadApartments().then(function (apartments) {
          context.commit('loadApartments', apartments);
        });
      }
    },
    loadDigitalResources: function loadDigitalResources(context) {
      if (state.digitalResources.length === 0) {
        __WEBPACK_IMPORTED_MODULE_5__components_digitalResources_digitalResources_service__["a" /* default */].loadDigitalResources().then(function (digitalResources) {
          context.commit('loadDigitalResources', digitalResources);
        });
      }
    },
    loadChildCarePrograms: function loadChildCarePrograms(context) {
      if (state.childCarePrograms.length === 0) {
        __WEBPACK_IMPORTED_MODULE_6__components_childCarePrograms_childCarePrograms_service__["a" /* default */].loadChildCare().then(function (childCarePrograms) {
          context.commit('loadChildCarePrograms', childCarePrograms);
        });
      }
    },
    loadFamilyDayCarePrograms: function loadFamilyDayCarePrograms(context) {
      if (state.familyDayCarePrograms.length === 0) {
        __WEBPACK_IMPORTED_MODULE_6__components_childCarePrograms_childCarePrograms_service__["a" /* default */].loadFamilyDayCare().then(function (familyDayCarePrograms) {
          context.commit('loadFamilyDayCarePrograms', familyDayCarePrograms);
        });
      }
    },
    loadParkAccessibilities: function loadParkAccessibilities(context) {
      if (state.parkAccessibilities.length === 0) {
        __WEBPACK_IMPORTED_MODULE_8__components_parksAccessibility_parksAccessibility_service__["a" /* default */].loadParkAccessibilities().then(function (parkAccessibilities) {
          context.commit('loadParkAccessibilities', parkAccessibilities);
        });
      }
    },
    loadFoodResources: function loadFoodResources(context) {
      if (state.foodResources.length === 0) {
        __WEBPACK_IMPORTED_MODULE_7__components_foodResources_foodResources_service__["a" /* default */].loadFoodResources().then(function (data) {
          context.commit('loadFoodResources', data);
        });
      }
    }
  },
  mutations: {
    loadProjects: function loadProjects(state, projects) {
      state.projects = state.projects.concat(projects);
      state.projectsLoaded = true;
    },
    loadDailyWork: function loadDailyWork(state, dailyWork) {
      state.projects = state.projects.concat(dailyWork);
      state.dailyWorkLoaded = true;
    },
    loadCivic: function loadCivic(state, civicAssns) {
      state.civicAssociations = civicAssns;
    },
    loadVoterPrecincts: function loadVoterPrecincts(state, voter) {
      state.voterPrecincts = voter;
    },
    loadApartments: function loadApartments(state, apartments) {
      state.apartments = apartments;
    },
    loadDigitalResources: function loadDigitalResources(state, digitalResources) {
      state.digitalResources = digitalResources;
    },
    loadChildCarePrograms: function loadChildCarePrograms(state, childCarePrograms) {
      state.childCarePrograms = childCarePrograms;
    },
    loadFamilyDayCarePrograms: function loadFamilyDayCarePrograms(state, familyDayCarePrograms) {
      state.familyDayCarePrograms = familyDayCarePrograms;
    },
    loadParkAccessibilities: function loadParkAccessibilities(state, parkAccessibilities) {
      state.parkAccessibilities = parkAccessibilities;
    },
    loadFoodResources: function loadFoodResources(state, data) {
      state.foodResources = data;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  computed: {
    embed: function embed() {
      return this.$route.query && this.$route.query.embed && this.$route.query.embed === 'true';
    }
  }
});

/***/ }),

/***/ "xODz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y+uY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("/9yN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23812a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("rNJm");
function injectStyle (ssrContext) {
  __webpack_require__("GrVM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23812a70"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23812a70_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y/ug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington - Projects")])],1),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget"},[(_vm.project)?_c('div',[_c('h3',{domProps:{"innerHTML":_vm._s('Building Permits for ' + _vm.project.title)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',[_c('tbody',[_vm._m(0),_vm._v(" "),_vm._l((_vm.permits),function(permit){return _c('tr',{key:permit.permitKey},[_c('td',[_c('a',{attrs:{"target":"_blank","href":'https://permits.arlingtonva.us/Permit_Status.aspx?p_number=' + permit.permitNbr}},[_vm._v(_vm._s(permit.permitNbr))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.streetAddressText))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.permitTypeCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.permitStatusCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.permitHolderName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.propertyOwnerName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("defaultDate")(permit.appliedDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("defaultDate")(permit.approveDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("defaultDate")(permit.issuedDate)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(permit.permitDescriptionText))])])})],2)])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Permit #")]),_vm._v(" "),_c('td',[_vm._v("Address")]),_vm._v(" "),_c('td',[_vm._v("Type")]),_vm._v(" "),_c('td',[_vm._v("Status")]),_vm._v(" "),_c('td',[_vm._v("Permit Holder")]),_vm._v(" "),_c('td',[_vm._v("Owner")]),_vm._v(" "),_c('td',[_vm._v("Applied Date")]),_vm._v(" "),_c('td',[_vm._v("Approved Date")]),_vm._v(" "),_c('td',[_vm._v("Date Issued")]),_vm._v(" "),_c('td',[_vm._v("Description")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yPNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder"},[_c('h2',[_vm._v("Page not found.")]),_vm._v(" "),_c('p',[_vm._v("We're sorry.  We were unable to find this page.  Please go back and try again or "),_c('a',{attrs:{"href":"https://www.arlingtonva.us/contact-arlington/"}},[_vm._v("contact us.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zL/c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("My Arlington -")]),_c('router-link',{attrs:{"to":"/digitalresources"}},[_vm._v(" Digital Resources")])],1)]),_vm._v(" "),(_vm.alert)?_c('v-flex',{staticClass:"layer-page"},[_c('v-alert',{attrs:{"dismissible":"","id":"dr-alert","click":"openCovidPage()"},model:{value:(_vm.alert),callback:function ($$v) {_vm.alert=$$v},expression:"alert"}},[_c('span',{attrs:{"click":"openCovidPage()"}},[_vm._v("Hours or services may differ due to COVID-19. Please refer to the "),_c('a',{attrs:{"href":"https://www.arlingtonva.us/covid-19/operational-status/"}},[_vm._v("County's Operational Status page")]),_vm._v(" for more details.")])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                  Filters and Location\n                  "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                              "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Availability")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Computer',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Computer')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Computer',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.filterChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('DesktopIcon',{attrs:{"title":"Computer"}}),_vm._v(" Computer")],1)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'WiFi',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'WiFi')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='WiFi',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.wifiChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('WifiIcon',{attrs:{"title":"Wi-Fi"}}),_vm._v(" Wi-Fi")],1)]),_vm._v(" "),(_vm.typeSelected.includes('WiFi'))?_c('div',{staticClass:"filter-item filter-item-nested"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'IndoorWiFi',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'IndoorWiFi')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='IndoorWiFi',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.wifiChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('WifiIcon',{attrs:{"title":"Wi-Fi"}}),_vm._v(" Indoor\n                                "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Free public Wi-Fi available inside the facility.")])],1)]):_vm._e(),_vm._v(" "),(_vm.typeSelected.includes('WiFi'))?_c('div',{staticClass:"filter-item filter-item-nested"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'DriveWiFi',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'DriveWiFi')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='DriveWiFi',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.wifiChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('WifiIcon',{staticClass:"wifi-icon-outdoor",attrs:{"title":"Wi-Fi"}}),_vm._v(" Outdoor\n                                "),_c('span',{staticClass:"tooltiptext"},[_vm._v("Free public Wi-Fi available outside the facility.")])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Printing',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Printing')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Printing',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.filterChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('PrinterIcon',{attrs:{"title":"Printer"}}),_vm._v(" Printer")],1)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Scanning',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Scanning')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Scanning',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.filterChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('ScannerIcon',{attrs:{"title":"Scanner"}}),_vm._v(" Scanner")],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"},[_c('br'),_vm._v(" "),_c('div',{staticClass:"filter-item filter-category"},[_vm._v("Public Transit")]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Bus',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Bus')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Bus',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.filterChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('BusIcon',{attrs:{"title":"Bus"}}),_vm._v(" Bus")],1)]),_vm._v(" "),_c('div',{staticClass:"filter-item"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.typeSelected),expression:"typeSelected"}],attrs:{"type":"checkbox"},domProps:{"value":'Metro',"checked":Array.isArray(_vm.typeSelected)?_vm._i(_vm.typeSelected,'Metro')>-1:(_vm.typeSelected)},on:{"change":[function($event){var $$a=_vm.typeSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v='Metro',$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.typeSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.typeSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.typeSelected=$$c}},function($event){return _vm.filterChange($event)}]}}),_vm._v(" "),_c('span',{staticClass:"tooltip"},[_c('SubwayIcon',{attrs:{"title":"Metro"}}),_vm._v(" Metro")],1)])])])]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Facility")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.facilitySelected),expression:"facilitySelected"}],attrs:{"id":"facility"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.facilitySelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.facilityChange($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a facility")]),_vm._v(" "),_vm._l((_vm.facilities),function(f){return _c('option',{key:f,domProps:{"value":f}},[_vm._v(_vm._s(f))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Facility Type")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.facilityTypeSelected),expression:"facilityTypeSelected"}],attrs:{"id":"facilitytype"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.facilityTypeSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.facilityChange($event)}]}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a facility type")]),_vm._v(" "),_vm._l((_vm.facilityTypes),function(f){return _c('option',{key:f,domProps:{"value":f}},[_vm._v(_vm._s(f))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Within")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.radiusSelected),expression:"radiusSelected"}],attrs:{"id":"civicAssociation","disabled":!_vm.selectedCoordinates},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.radiusSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Set radius")]),_vm._v(" "),_c('option',{attrs:{"value":"0.5"}},[_vm._v("0.5 Mile")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Mile")])])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.civicAssociationFailure),expression:"civicAssociationFailure"}]},[_vm._v("Unable to load Civic Assocations.")])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles,"id":"vue-map-container"}},[_vm._l((_vm.filteredDigitalResources),function(digitalResource){return _c('gmap-marker',{key:digitalResource.Facility,attrs:{"position":digitalResource,"icon":_vm.icon,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(digitalResource, e); }}})}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('div',{staticClass:"info-window"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"header-column-left"},[_c('h3',{staticClass:"info-window-header"},[_c('b',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.Facility)},on:{"click":function($event){return _vm.openLink(_vm.selectedItem['Facility Website'])}}})])]),_vm._v(" "),_c('div',{staticClass:"header-column-right"},[(_vm.selectedItem['Computers available?'] == 'Yes' || _vm.selectedItem['Wi-Fi'] == 'Yes' || _vm.selectedItem['Printing?'] == 'Yes' || _vm.selectedItem['Availability'] == 'Yes')?_c('span',[(_vm.selectedItem['Computers available?'] == 'Yes')?_c('DesktopIcon',{attrs:{"title":"Computer"}}):_vm._e(),_vm._v(" "),(_vm.selectedItem['Wi-Fi'] == 'Yes')?_c('WifiIcon',{attrs:{"title":"Indoor Wi-Fi"}}):_vm._e(),_vm._v(" "),(_vm.selectedItem['Availability'] == 'Yes')?_c('WifiIcon',{staticClass:"wifi-icon-outdoor",attrs:{"title":"Outdoor Wi-Fi"}}):_vm._e(),_vm._v(" "),(_vm.selectedItem['Printing'] == 'Yes')?_c('PrinterIcon',{attrs:{"title":"Printer"}}):_vm._e(),_vm._v(" "),(_vm.selectedItem['Scanning'] == 'Yes')?_c('ScannerIcon',{attrs:{"title":"Scanner"}}):_vm._e()],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"column"},[_c('span',[_vm._v(_vm._s(_vm.selectedItem['Street Address - Line 1']))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedItem['Phone Number']))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"transit-row"},[(_vm.selectedItem['Bus'] == 'Yes')?_c('BusIcon',{attrs:{"title":"Bus"}}):_vm._e(),_vm._v(" "),(_vm.selectedItem['Metro'] == 'Yes')?_c('SubwayIcon',{attrs:{"title":"Metro"}}):_vm._e()],1),_c('br')]),_vm._v(" "),_c('div',{staticClass:"column"},[(_vm.selectedItem['Days of Operation'] && _vm.selectedItem['Days of Operation'] != 'N/A' && _vm.selectedItem['Hours'] && _vm.selectedItem['Hours'] != 'N/A')?_c('b',[_vm._v("Hours")]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Days of Operation'] && _vm.selectedItem['Days of Operation'] != 'N/A' && _vm.selectedItem['Hours'] && _vm.selectedItem['Hours'] != 'N/A')?_c('ul',{staticClass:"operations-list"},_vm._l((_vm.selectedItem['Days of Operation']),function(day,index){return _c('li',{key:day},[_vm._v(_vm._s(day)+": "+_vm._s(_vm.selectedItem['Hours'][index]))])}),0):_vm._e()])]),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"info-window-body"},[(_vm.selectedItem['Specialty Software'] && _vm.selectedItem['Specialty Software'] != 'N/A')?_c('span',[_c('b',[_vm._v("Specialty Software:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Specialty Software'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Accessibility'] && _vm.selectedItem['Accessibility'] != 'N/A')?_c('span',[_c('b',[_vm._v("Accessibility Computers:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Accessibility'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Eligibility Requirements'] && _vm.selectedItem['Eligibility Requirements'] != 'N/A')?_c('span',[_c('b',[_vm._v("Eligibility Requirements:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedItem['Eligibility Requirements'])}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Printing'] == 'Yes')?_c('span',[_c('b',[_vm._v("Printing Cost Per Page:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Printing Cost Per Page'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Reservations Needed?'] == 'Yes')?_c('span',[_c('b',[_vm._v("Reservations Needed:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Reservations Needed?'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Reservations Needed?'] == 'Yes' && _vm.selectedItem['Reservation Requirements'] != 'N/A')?_c('span',[_c('b',[_vm._v("Reservation Requirements:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedItem['Reservation Requirements'])}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Assistance Languages'] && _vm.selectedItem['Assistance Languages'] != 'N/A')?_c('span',[_c('b',[_vm._v("Assistance Languages:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Assistance Languages'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Trainings'] && _vm.selectedItem['Trainings'] != 'N/A')?_c('span',[_c('b',[_vm._v("Trainings:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedItem['Trainings'])}}),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Target Populations'] && _vm.selectedItem['Target Populations'] != 'N/A')?_c('span',[_c('b',[_vm._v("Target Populations:")]),_vm._v(" "+_vm._s(_vm.selectedItem['Target Populations'])),_c('br')]):_vm._e(),_vm._v(" "),(_vm.selectedItem['Notes/comments'] && _vm.selectedItem['Notes/comments'] != 'N/A')?_c('span',[_c('b',[_vm._v("Additional Information:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedItem['Notes/comments'])}}),_c('br')]):_vm._e()])])]),_vm._v(" "),(_vm.selectedCoordinates && !_vm.selectedCoordinates.fac)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e(),_vm._v(" "),(_vm.selectedCoordinates && _vm.radiusSelected)?_c('GmapCircle',{attrs:{"center":_vm.selectedCoordinates,"radius":_vm.radiusSelected*1609,"visible":true,"options":{fillColor:'blue',fillOpacity:0.1,strokeWeight:0.7,strokeColor:'blue'}}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredDigitalResources),function(digitalResource){return _c('div',{key:digitalResource.Facility,staticClass:"project"},[_c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"list-header-column-left"},[_c('h3',{staticClass:"h3-list"},[_c('b',{domProps:{"innerHTML":_vm._s(digitalResource.Facility)},on:{"click":function($event){return _vm.openLink(digitalResource['Facility Website'])}}})])]),_vm._v(" "),_c('div',{staticClass:"list-header-column-right"},[(digitalResource['Computers available?'] == 'Yes' || digitalResource['Wi-Fi'] == 'Yes' || digitalResource['Printing?'] == 'Yes' || digitalResource['Availability'] == 'Yes')?_c('span',[(digitalResource['Computers available?'] == 'Yes')?_c('DesktopIcon',{attrs:{"title":"Computer"}}):_vm._e(),_vm._v(" "),(digitalResource['Wi-Fi'] == 'Yes')?_c('WifiIcon',{attrs:{"title":"Indoor Wi-Fi"}}):_vm._e(),_vm._v(" "),(digitalResource['Availability'] == 'Yes')?_c('WifiIcon',{staticClass:"wifi-icon-outdoor",attrs:{"title":"Outdoor Wi-Fi"}}):_vm._e(),_vm._v(" "),(digitalResource['Printing'] == 'Yes')?_c('PrinterIcon',{attrs:{"title":"Printer"}}):_vm._e(),_vm._v(" "),(digitalResource['Scanning'] == 'Yes')?_c('ScannerIcon',{attrs:{"title":"Scanner"}}):_vm._e(),_vm._v(" "),_c('br')],1):_vm._e()])]),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[_c('span',[_vm._v(_vm._s(digitalResource['Street Address - Line 1']))]),_vm._v(" "),(digitalResource['Phone Number'])?_c('span',[_c('br'),_vm._v(_vm._s(digitalResource['Phone Number']))]):_vm._e(),_c('br'),_vm._v(" "),_c('span',{staticClass:"transit-row"},[(digitalResource['Bus'] == 'Yes')?_c('BusIcon',{attrs:{"title":"Bus"}}):_vm._e(),_vm._v(" "),(digitalResource['Metro'] == 'Yes')?_c('SubwayIcon',{attrs:{"title":"Metro"}}):_vm._e()],1),_c('br')]),_c('br'),_vm._v(" "),_c('p',[(digitalResource['Days of Operation'] && digitalResource['Days of Operation'] != 'N/A' && digitalResource['Hours'] && digitalResource['Hours'] != 'N/A')?_c('b',[_vm._v("Hours")]):_vm._e(),_vm._v(" "),(digitalResource['Days of Operation'] && digitalResource['Days of Operation'] != 'N/A' && digitalResource['Hours'] && digitalResource['Hours'] != 'N/A')?_c('ul',{staticClass:"operations-list"},_vm._l((digitalResource['Days of Operation']),function(day,index){return _c('li',{key:day},[_vm._v(_vm._s(day)+": "+_vm._s(digitalResource['Hours'][index]))])}),0):_vm._e()]),_c('br'),_vm._v(" "),_c('p',{staticClass:"no-vertical-margin"},[(digitalResource['Specialty Software'] && digitalResource['Specialty Software'] != 'N/A')?_c('span',[_c('b',[_vm._v("Specialty Software:")]),_vm._v(" "+_vm._s(digitalResource['Specialty Software'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Accessibility'] && digitalResource['Accessibility'] != 'N/A')?_c('span',[_c('b',[_vm._v("Accessibility Computers:")]),_vm._v(" "+_vm._s(digitalResource['Accessibility'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Eligibility Requirements'] && digitalResource['Eligibility Requirements'] != 'N/A')?_c('span',[_c('b',[_vm._v("Eligibility Requirements:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(digitalResource['Eligibility Requirements'])}}),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Printing'] == 'Yes')?_c('span',[_c('b',[_vm._v("Printing Cost Per Page:")]),_vm._v(" "+_vm._s(digitalResource['Printing Cost Per Page'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Reservations Needed?'] == 'Yes')?_c('span',[_c('b',[_vm._v("Reservations Needed:")]),_vm._v(" "+_vm._s(digitalResource['Reservations Needed?'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Reservations Needed?'] == 'Yes' && digitalResource['Reservation Requirements'] != 'N/A')?_c('span',[_c('b',[_vm._v("Reservation Requirements:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(digitalResource['Reservation Requirements'])}}),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Assistance Languages'] && digitalResource['Assistance Languages'] != 'N/A')?_c('span',[_c('b',[_vm._v("Assistance Languages:")]),_vm._v(" "+_vm._s(digitalResource['Assistance Languages'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Trainings'] && digitalResource['Trainings'] != 'N/A')?_c('span',[_c('b',[_vm._v("Trainings:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(digitalResource['Trainings'])}}),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Target Populations'] && digitalResource['Target Populations'] != 'N/A')?_c('span',[_c('b',[_vm._v("Target Populations:")]),_vm._v(" "+_vm._s(digitalResource['Target Populations'])),_c('br')]):_vm._e(),_vm._v(" "),(digitalResource['Notes/comments'] && digitalResource['Notes/comments'] != 'N/A')?_c('span',[_c('b',[_vm._v("Additional Information:")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(digitalResource['Notes/comments'])}}),_c('br')]):_vm._e()])])])}),0)],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zXeE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apartments_vue__ = __webpack_require__("I2zp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2be22f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Apartments_vue__ = __webpack_require__("bOdf");
function injectStyle (ssrContext) {
  __webpack_require__("xODz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b2be22f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Apartments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2be22f6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Apartments_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zuWS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"page-header"}},[_c('router-link',{attrs:{"to":"/"}}),_c('router-link',{attrs:{"to":"/projects"}},[_vm._v(" Daily Infrastructure Work Around the County")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"layer-page"},[_c('div',{staticClass:"widget one-third filter-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMobile || _vm.mobileMenu === false),expression:"isMobile || mobileMenu === false"}],staticClass:"filter-header",attrs:{"id":"mobile-menu"},on:{"click":function($event){_vm.mobileMenu = !_vm.mobileMenu}}},[_vm._v("\n                Filters and Location\n                "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.mobileMenu),expression:"!mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileMenu),expression:"mobileMenu"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile || _vm.mobileMenu),expression:"!isMobile || mobileMenu"}],attrs:{"id":"filters-and-settings"}},[_c('div',{staticClass:"filter-container"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMobile),expression:"!isMobile"}],staticClass:"filter-header",on:{"click":_vm.filtersToggle}},[_c('span',[_vm._v("Filters\n                            "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded),expression:"filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-minus"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(!_vm.filtersExpanded),expression:"!filtersExpanded"}],staticClass:"icon",staticStyle:{"float":"right"}},[_c('use',{attrs:{"xlink:href":"#icon-plus"}})]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filtersExpanded || _vm.mobileMenu),expression:"filtersExpanded || mobileMenu"}],staticClass:"filterList"})]),_vm._v(" "),_c('h3',[_vm._v("Zoom to Location")]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"filter-header",on:{"click":_vm.getCurrentLocation}},[_vm._v("Your Current Location")])]),_vm._v(" "),_c('div',{staticClass:"filter-container zoom-container"},[_c('label',{attrs:{"for":"addressSearch"}},[_vm._v("Address")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('gmap-autocomplete',{ref:"autocomplete",on:{"place_changed":_vm.placeChanged}})],1),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('label',{attrs:{"for":"civicAssociation"}},[_vm._v("Civic Association")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.civicAssocationsSelected),expression:"civicAssocationsSelected"}],attrs:{"id":"civicAssociation"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.civicAssocationsSelected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":""}},[_vm._v("Select a civic association")]),_vm._v(" "),_vm._l((_vm.civicAssociations),function(ca){return _c('option',{key:ca.OBJECTID,domProps:{"value":ca}},[_vm._v(_vm._s(ca.LABEL))])})],2)]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.civicAssociationFailure),expression:"civicAssociationFailure"}]},[_vm._v("Unable to load Civic Assocations.")])]),_vm._v(" "),_c('div',{staticClass:"filter-container"},[_c('button',{staticClass:"link filter-header",on:{"click":_vm.clearAll}},[_vm._v("Clear All")])])])]),_vm._v(" "),_c('div',{staticClass:"widget full-map-pane toggle-window"},[_c('div',{staticStyle:{"position":"relative","top":"0"}},[_c('h3',{staticClass:"toggle-bar"},[_c('a',{class:_vm.showMap === true ? 'toggle-link' : 'toggle-link active',on:{"click":function($event){_vm.showMap = true}}},[_vm._v("Map")]),_vm._v(" "),_c('a',{class:_vm.showMap === false ? 'toggle-link' : 'toggle-link active',attrs:{"id":"list-link"},on:{"click":function($event){_vm.showMap = false}}},[_vm._v("List")])])]),_vm._v(" "),_c('gmap-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],attrs:{"center":_vm.mapCenter,"zoom":_vm.zoomLevel,"options":_vm.mapStyles}},[_vm._l((_vm.filteredProjects),function(project){return _c('div',{key:project.id},_vm._l((project.shapes),function(shape){return _c('div',{key:project.id + '_' + shape},[(shape.shape === 'polygon')?_c('gmap-polygon',{attrs:{"paths":shape.coordinates,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(project, e); }}}):_vm._e(),_vm._v(" "),(shape.shape === 'polyline')?_c('gmap-polyline',{attrs:{"path":shape.coordinates,"options":_vm.shapeOptions},on:{"click":function (e) { return _vm.shapeClick(project, e); }}}):_vm._e(),_vm._v(" "),(shape.shape === 'marker')?_c('gmap-circle',{key:shape.id,attrs:{"center":shape.coordinates,"options":_vm.shapeOptions,"radius":32},on:{"click":function (e) { return _vm.shapeClick(project, e); }}}):_vm._e()],1)}),0)}),_vm._v(" "),_c('gmap-info-window',{attrs:{"opened":_vm.selectedInfoWindowPosition !== null,"position":_vm.selectedInfoWindowPosition},on:{"closeclick":_vm.infoWindowCloseClick}},[_c('div',{staticClass:"info-window"},[_c('b',[(!_vm.selectedItem.hideUrl)?_c('a',{attrs:{"href":_vm.selectedItem.url,"target":"_blank"},domProps:{"innerHTML":_vm._s(_vm.selectedItem.title)}},[_vm._v("Website")]):_vm._e(),_vm._v(" "),(_vm.selectedItem.hideUrl)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.title)}},[_vm._v("Website")]):_vm._e()]),_vm._v(" "),(_vm.selectedItem.content)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.selectedItem.content)}}):_vm._e(),_vm._v(" "),(_vm.selectedItem.buildingPermitList)?_c('div',[_c('router-link',{attrs:{"to":{ name: 'Project', params: { id: _vm.selectedItem.id }}}},[_vm._v("Permits")])],1):_vm._e()])]),_vm._v(" "),(_vm.selectedCoordinates)?_c('gmap-marker',{attrs:{"position":_vm.selectedCoordinates,"radius":24}}):_vm._e(),_vm._v(" "),(_vm.civicAssocationsSelected)?_c('gmap-polygon',{attrs:{"path":_vm.civicAssocationsSelected.paths,"options":_vm.locationOptions}}):_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showMap),expression:"!showMap"}],staticClass:"list-pane"},_vm._l((_vm.filteredProjects),function(project){return _c('div',{key:project.id,staticClass:"project"},[_c('h3',[(project.hideUrl)?_c('a',{domProps:{"innerHTML":_vm._s(project.title)}}):_vm._e(),_vm._v(" "),(!project.hideUrl)?_c('a',{attrs:{"href":project.url},domProps:{"innerHTML":_vm._s(project.title)}}):_vm._e()]),_vm._v(" "),(project.content)?_c('p',{staticClass:"no-vertical-margin",domProps:{"innerHTML":_vm._s(project.content)}}):_vm._e(),_vm._v(" "),(project.buildingPermitList)?_c('p',{staticClass:"no-vertical-margin"},[_c('router-link',{attrs:{"to":{ name: 'Project', params: { id: project.id }}}},[_vm._v("Permits")])],1):_vm._e()])}),0)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blurb"}},[_c('p',[_vm._v("\n              Find infrastructure maintenance and repairs happening around the County. Don't see work represented on the map? It may be a Washington Gas, Dominion Power, VDOT, APS or private ownership project.\n              Or check our "),_c('a',{attrs:{"href":"https://my.arlingtonva.us/projects"}},[_vm._v(" Projects pages")]),_vm._v(".\n          ")]),_vm._v(" "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.e05ee3fbba7bd52b32df.js